<template>
  <div class="c1-main c1-brokers-page" @click="c1HamMenuOpen = false; c1ShiftMenuOpen = false; c1TopTab = null">

    <!-- TOAST -->
    <transition name="br1-toast-fade">
      <div v-if="b1Toast" class="br1-toast" :style="{ background: b1Toast.color }">{{ b1Toast.msg }}</div>
    </transition>

    <div class="c1-sticky-top">
    <!-- TOP BAR -->
    <div class="c1-tib" @click.stop="c1SlideOpen = null; c1VikiOpen = false">
      <!-- LEFT 25% — Viki face flush left -->
      <div class="c1-tib-side c1-tib-left" style="padding-left:0;gap:8px;">
        <div class="c1-viki-topface"
          :class="{ 'c1-viki-topface--active': c1PanelActiveContent === 'viki' }"
          @click.stop="c1SelectPanel('viki','')"
        >
          <viki-face :mood="c1VikiMood" :speaking="c1VikiSpeaking" :size="44" style="width:72px;height:44px;display:block;overflow:hidden;border-radius:0;"/>
        </div>
        <div class="c1-shift-wrap" @click.stop="c1ShiftMenuOpen = !c1ShiftMenuOpen; c1HamMenuOpen = false">
          <div class="c1-tib-shift-pill" :class="{ open: c1ShiftMenuOpen }">
            ⏱ {{ c1ShiftElapsed }}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:10px;height:10px;margin-left:3px;transition:transform .2s" :style="{ transform: c1ShiftMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)' }"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>
      </div>
      <!-- CENTER 50% -->
      <div class="c1-tib-center">
        <div class="c1-tib-mod-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>
          Brokers
        </div>
      </div>
      <!-- RIGHT 25% -->
      <div class="c1-tib-side c1-tib-right">
        <div class="c1-ham-wrap" @click.stop>
          <button class="c1-ham-btn" :class="{ open: c1HamMenuOpen }" @click="c1HamMenuOpen = !c1HamMenuOpen; c1ShiftMenuOpen = false">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
        </div>
      </div>
    </div>
    <!-- SHIFT DRAWER -->
    <div class="c1-top-drawer c1-shift-drawer" :class="{ open: c1ShiftMenuOpen }" @click.stop>
      <div class="c1-td-inner">
        <div class="c1-td-section-lbl">My Shift</div>
        <div class="c1-td-status-row">
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono">{{ c1ShiftStartTime ? new Date(c1ShiftStartTime).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '—' }}</div>
            <div class="c1-td-stat-lbl">Started</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono" style="color:var(--c1-dp)">{{ c1ShiftElapsed }}</div>
            <div class="c1-td-stat-lbl">Elapsed</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1BathroomCount }}×</div>
            <div class="c1-td-stat-lbl">🚽 Bathroom</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1CoffeeCount }}×</div>
            <div class="c1-td-stat-lbl">☕ Coffee</div>
          </div>
        </div>
        <div class="c1-td-btn-row">
          <button class="c1-td-btn c1-td-btn-shift"   :class="{ active: c1Status === 'shift' }"   @click.stop="c1SetStatus('shift')">▶ On Shift</button>
          <button class="c1-td-btn c1-td-btn-bathroom" :class="{ active: c1Status === 'bathroom' }" @click.stop="c1SetStatus('bathroom')">🚽 Bathroom</button>
          <button class="c1-td-btn c1-td-btn-coffee"  :class="{ active: c1Status === 'coffee' }"  @click.stop="c1SetStatus('coffee')">☕ Coffee</button>
          <button class="c1-td-btn c1-td-btn-break"   :class="{ active: c1Status === 'break' }"   @click.stop="c1SetStatus('break')">⏸ Break</button>
          <button class="c1-td-btn c1-td-btn-lunch"   :class="{ active: c1Status === 'lunch' }"   @click.stop="c1SetStatus('lunch')">🍽 Lunch</button>
          <button class="c1-td-btn c1-td-btn-end"     @click.stop="c1SetStatus('end')">⏹ End Shift</button>
        </div>
      </div>
    </div>
    <!-- HAM NAV DRAWER -->
    <div class="c1-top-drawer c1-ham-drawer" :class="{ open: c1HamMenuOpen }" @click.stop>
      <div class="c1-td-inner c1-td-nav-grid">
        <router-link to="/clients1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-dp)"></span>Clients</router-link>
        <router-link to="/tasks1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-sc)"></span>Tasks</router-link>
        <router-link to="/stats1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-ld)"></span>Statistics</router-link>
        <router-link to="/chat1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-rf)"></span>Chat</router-link>
        <router-link to="/communications1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#3b82f6"></span>Communications</router-link>
        <router-link to="/affiliation1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#8b5cf6"></span>Affiliation</router-link>
        <router-link to="/finance1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#10b981"></span>Finance</router-link>
        <router-link to="/shifts1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#f59e0b"></span>Shifts</router-link>
        <router-link to="/users1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#06b6d4"></span>Users</router-link>
        <router-link to="/brokers1" class="c1-td-nav-item" :class="{ on: $route.path === '/brokers1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ec4899"></span>Brokers</router-link>
        <router-link to="/security1" class="c1-td-nav-item" :class="{ on: $route.path === '/security1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ef4444"></span>Security</router-link>
        <router-link to="/quiz1" class="c1-td-nav-item" :class="{ on: $route.path === '/quiz1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#a78bfa"></span>Quiz</router-link>
        <router-link to="/instruction1" class="c1-td-nav-item" :class="{ on: $route.path === '/instruction1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#64748b"></span>Instructions</router-link>
        <router-link to="/settings1" class="c1-td-nav-item" :class="{ on: $route.path === '/settings1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#94a3b8"></span>Settings</router-link>
        <router-link to="/profile1" class="c1-td-nav-item" :class="{ on: $route.path === '/profile1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#22d3ee"></span>My Profile</router-link>
      </div>
    </div>
    </div><!-- /c1-sticky-top -->

    <!-- TOP STRIP (filter tabs - always visible) -->
    <div class="c1-top-strip c1-mod-strip" @click.stop>
      <div class="c1-top-strip-body">
        <div class="c1-ts-tab-row">
          <!-- Status tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'status'}" @click.stop="c1TopTab = c1TopTab === 'status' ? null : 'status'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span>Status</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='status' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <!-- Regulated tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'regulated'}" @click.stop="c1TopTab = c1TopTab === 'regulated' ? null : 'regulated'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            <span>Regulated</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='regulated' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <!-- Deposit tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'deposit'}" @click.stop="c1TopTab = c1TopTab === 'deposit' ? null : 'deposit'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
            <span>Min Deposit</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='deposit' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <!-- Sort tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'sort'}" @click.stop="c1TopTab = c1TopTab === 'sort' ? null : 'sort'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
            <span>Sort</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='sort' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <!-- Search tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'search'}" @click.stop="c1TopTab = c1TopTab === 'search' ? null : 'search'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <span>Search</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='search' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <!-- Charts tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'charts'}" @click.stop="c1TopTab = c1TopTab === 'charts' ? null : 'charts'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
            <span>Charts</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='charts' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>

        <!-- Status dropdown -->
        <div v-show="c1TopTab === 'status'" class="c1-ts-dropdown" @click.stop>
          <div v-if="b1ActiveFilterCount" class="c1-reset-bar" @click="b1ResetFilters()">
            <svg viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
            Reset all filters
            <span class="c1-reset-bar-count">{{ b1ActiveFilterCount }}</span>
          </div>
          <div class="c1-fp-group">
            <div class="c1-fp-lbl">Status</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" :class="{ on: b1Filters.active === null }" @click="b1Filters.active = null; b1Load()">All</div>
              <div class="c1-fp-opt" :class="{ on: b1Filters.active === true }" @click="b1Filters.active = true; b1Load()">Active</div>
              <div class="c1-fp-opt" :class="{ on: b1Filters.active === false }" @click="b1Filters.active = false; b1Load()">Inactive</div>
            </div>
          </div>
          <div class="c1-fp-group">
            <div class="c1-fp-lbl">Count Twice</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" :class="{ on: b1Filters.count_twice === null }" @click="b1Filters.count_twice = null; b1Load()">All</div>
              <div class="c1-fp-opt b1-chip-ct" :class="{ on: b1Filters.count_twice === true }" @click="b1Filters.count_twice = true; b1Load()">Count Twice</div>
              <div class="c1-fp-opt" :class="{ on: b1Filters.count_twice === false }" @click="b1Filters.count_twice = false; b1Load()">Normal</div>
            </div>
          </div>
        </div>

        <!-- Regulated dropdown -->
        <div v-show="c1TopTab === 'regulated'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-group">
            <div class="c1-fp-lbl">Regulated</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" :class="{ on: b1Filters.regulated === null }" @click="b1Filters.regulated = null; b1Load()">All</div>
              <div class="c1-fp-opt b1-chip-reg" :class="{ on: b1Filters.regulated === true }" @click="b1Filters.regulated = true; b1Load()">Regulated</div>
              <div class="c1-fp-opt b1-chip-unreg" :class="{ on: b1Filters.regulated === false }" @click="b1Filters.regulated = false; b1Load()">Not Regulated</div>
            </div>
          </div>
        </div>

        <!-- Min Deposit dropdown -->
        <div v-show="c1TopTab === 'deposit'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-group c1-fp-full">
            <div class="c1-fp-lbl">Min Deposit Range ($)</div>
            <div class="b1-range-row">
              <input class="b1-range-input" type="number" v-model.number="b1Filters.minDepositMin" placeholder="From" min="0" @change="b1Load()" />
              <span class="b1-range-sep">—</span>
              <input class="b1-range-input" type="number" v-model.number="b1Filters.minDepositMax" placeholder="To" min="0" @change="b1Load()" />
            </div>
          </div>
        </div>

        <!-- Sort dropdown -->
        <div v-show="c1TopTab === 'sort'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-group c1-fp-full">
            <div class="c1-fp-lbl">Sort by</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" :class="{ on: b1Sort === 'name_asc' }" @click="b1Sort = 'name_asc'">Name A→Z</div>
              <div class="c1-fp-opt" :class="{ on: b1Sort === 'name_desc' }" @click="b1Sort = 'name_desc'">Name Z→A</div>
              <div class="c1-fp-opt" :class="{ on: b1Sort === 'cpa_desc' }" @click="b1Sort = 'cpa_desc'">CPA ↓</div>
              <div class="c1-fp-opt" :class="{ on: b1Sort === 'dep_desc' }" @click="b1Sort = 'dep_desc'">Deposits ↓</div>
              <div class="c1-fp-opt" :class="{ on: b1Sort === 'start_asc' }" @click="b1Sort = 'start_asc'">Oldest First</div>
              <div class="c1-fp-opt" :class="{ on: b1Sort === 'min_dep_desc' }" @click="b1Sort = 'min_dep_desc'">Min Dep ↓</div>
            </div>
          </div>
        </div>

        <!-- Search dropdown -->
        <div v-show="c1TopTab === 'search'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-group c1-fp-full">
            <div class="c1-fp-lbl">Search</div>
            <div class="c1-fp-search">
              <svg class="c1-fp-sico" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input class="c1-fp-sinput" v-model.trim="b1Filters.search" placeholder="Broker name…" type="text" @input="b1Load()" />
              <div v-if="b1Filters.search" class="c1-fp-sclear" @click="b1Filters.search = ''; b1Load()">
                <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </div>
            </div>
          </div>
        </div>

        <!-- Charts dropdown -->
        <div v-show="c1TopTab === 'charts'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-group c1-fp-full" style="padding:0">
            <div class="c1-co-lbl">Overview</div>
            <div class="c1-kpi-row">
              <div class="c1-kpi"><div class="c1-kpi-lbl">Total Brokers</div><div class="c1-kpi-val">{{ b1Stats.total }}</div></div>
              <div class="c1-kpi"><div class="c1-kpi-lbl">Active</div><div class="c1-kpi-val" style="color:#6366f1">{{ b1Stats.active }}</div></div>
              <div class="c1-kpi"><div class="c1-kpi-lbl">Deposits / mo</div><div class="c1-kpi-val" style="color:#22c55e">{{ b1Stats.depositsThisMonth }}</div></div>
              <div class="c1-kpi"><div class="c1-kpi-lbl">Avg CPA</div><div class="c1-kpi-val" style="color:#f59e0b">${{ b1Stats.avgCpa }}</div></div>
            </div>
          </div>
          <div class="c1-fp-group c1-fp-full" style="padding:0">
            <div class="c1-co-lbl">Deposits per Broker (top 10)</div>
            <div class="c1-vbar-chart">
              <div v-for="bar in b1DepBarData" :key="'dep-'+bar.name" class="c1-vbar-row">
                <div class="c1-vbar-lbl b1-vbar-lbl-broker">{{ bar.shortName }}</div>
                <div class="c1-vbar-track">
                  <div class="c1-vbar-fill b1-bar-fill" :style="{ width: bar.pct + '%' }"><span class="c1-vbar-val">{{ bar.val }}</span></div>
                </div>
              </div>
              <div v-if="b1DepBarData.length === 0" class="b1-chart-empty">No data</div>
            </div>
          </div>
          <div class="c1-fp-group c1-fp-full" style="padding:0">
            <div class="c1-co-lbl">CPA Comparison (top 10)</div>
            <div class="c1-vbar-chart">
              <div v-for="bar in b1CpaBarData" :key="'cpa-'+bar.name" class="c1-vbar-row">
                <div class="c1-vbar-lbl b1-vbar-lbl-broker">{{ bar.shortName }}</div>
                <div class="c1-vbar-track">
                  <div class="c1-vbar-fill b1-bar-fill-cpa" :style="{ width: bar.pct + '%' }"><span class="c1-vbar-val">${{ bar.val }}</span></div>
                </div>
              </div>
              <div v-if="b1CpaBarData.length === 0" class="b1-chart-empty">No data</div>
            </div>
          </div>
          <div class="c1-fp-group c1-fp-full" style="padding:0">
            <div class="c1-co-lbl">Global Deposit Pipeline</div>
            <div class="b1-pipeline-summary">
              <div v-for="stage in b1PipelineStages" :key="stage.key" class="b1-ps-item" :style="{ '--ps-clr': stage.color }">
                <div class="b1-ps-num">{{ b1GlobalPipeline[stage.key] || 0 }}</div>
                <div class="b1-ps-lbl">{{ stage.short }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="c1-nm-div"></div>
        <c1-mod-calendar :items="b1Brokers" dateField="created_at" itemLabel="brokers" style="flex-shrink:0" />

      </div>
    </div>
    <!-- /TOP STRIP -->

    <!-- PANEL BACKDROP -->
    <transition name="c1-bd-fade">
      <div v-if="c1SlideOpen" class="c1-panel-backdrop" @click.stop="c1SlideOpen = null"></div>
    </transition>

    <!-- ===== UNIFIED PANEL ===== -->
    <div class="c1-panel" :class="{ 'c1-panel--open': c1PanelIsOpen }" @click.capture="c1FilterPanelClick">
      <div class="c1-panel-track" :class="{ 'at-content': c1PanelAtContent }">

        <!-- SCREEN 0: NAV -->
        <div class="c1-panel-screen">
          <!-- ── USER STRIP ── -->
          <div class="c1-nav-user-strip">
            <div class="c1-nav-av">
              {{ c1UserInitials }}
              <span class="c1-nav-av-dot" :class="'c1-dst-' + c1Status"></span>
            </div>
            <div class="c1-nav-uinfo">
              <div class="c1-nav-uname">{{ c1UserFullName }}</div>
              <div class="c1-nav-urole">{{ c1RoleLabel }}</div>
            </div>
            <div class="c1-nav-status-wrap" @click.stop="c1StatusMenuOpen = !c1StatusMenuOpen">
              <div class="c1-nav-status-btn" :class="'c1-st-' + c1Status">
                <span class="c1-nav-status-sdot"></span>
                <span class="c1-nav-status-elapsed">{{ c1StatusElapsed }}</span>
              </div>
              <transition name="c1-sfade">
                <div v-if="c1StatusMenuOpen" class="c1-nav-status-menu">
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('available')"><span class="c1-nav-status-opt-dot c1-st-dot-available"></span>Available</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('bathroom')"><span class="c1-nav-status-opt-dot c1-st-dot-bathroom"></span>Bathroom</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('coffee')"><span class="c1-nav-status-opt-dot c1-st-dot-coffee"></span>Coffee break</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('shift')"><span class="c1-nav-status-opt-dot c1-st-dot-shift"></span>Start shift</div>
                  <div class="c1-nav-status-opt c1-sto-end" @click.stop="c1SetStatus('end')"><span class="c1-nav-status-opt-dot c1-st-dot-end"></span>End shift</div>
                </div>
              </transition>
            </div>
          </div>

          <!-- ── TIMEZONE BAR ── -->
          <div class="c1-nav-tz-bar">
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇬🇧</span><span class="c1-nav-tz-time">{{ c1TzUK }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇮🇱</span><span class="c1-nav-tz-time">{{ c1TzIL }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🏝</span><span class="c1-nav-tz-time">{{ c1TzCB }}</span></div>
          </div>

          <!-- ── NAVIGATE: all pages ── -->
          <div v-if="c1NavMode === 'navigate'" class="c1-sl-body" style="padding:6px 0 12px">
            <div class="c1-psel-sub c1-psel-sub-back" @click.stop="c1NavMode = 'panels'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="15 18 9 12 15 6"/></svg>
              <span class="c1-psel-sub-lbl">{{ c1CurrentPageLabel }}</span>
            <span class="c1-nav-x-btn" @click.stop="c1SlideOpen = null"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:15px;height:15px;display:block"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span></div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">CRM</div>
            <router-link class="c1-psel-sub" to="/clients1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Clients</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/tasks1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Tasks</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/stats1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Statistics</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/chat1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Chat</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/communications1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Communications</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/affiliation1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Affiliation</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Sales</div>
            <router-link class="c1-psel-sub" to="/finance1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Finance</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/shifts1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Shifts</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/games1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Games</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Team</div>
            <router-link class="c1-psel-sub" to="/users1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Users</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/brokers1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Brokers</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/security1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Security</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Admin</div>
            <router-link class="c1-psel-sub" to="/quiz1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Quiz</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/instruction1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Instructions</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/settings1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Settings</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/profile1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">My Profile</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
          </div>

          <!-- ── PANELS MODE ── -->
          <div v-else class="c1-sl-body" style="padding:6px 0 12px">

            <!-- Navigate row -->
            <div class="c1-psel-sub c1-psel-sub-navigate" @click.stop="c1NavMode = 'navigate'">
              <span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span>
              <span class="c1-psel-sub-lbl" style="font-weight:600;color:var(--c1-dp)">{{ c1CurrentPageLabel }}</span>
              <span class="c1-psel-sub-hint">Go to another page</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-divider"></div>

            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
              Filters
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'filters' }" @click.stop="c1SelectPanel('filters','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Broker Filters</span>
              <span class="c1-psel-sub-hint">Status, regulated, deposit range</span>
              <svg v-if="c1PanelActiveContent === 'filters'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
              Analytics
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'charts' }" @click.stop="c1SelectPanel('charts','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Analytics</span>
              <span class="c1-psel-sub-hint">CPA, deposits, pipeline overview</span>
              <svg v-if="c1PanelActiveContent === 'charts'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Calendar
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'calendar' }" @click.stop="c1SelectPanel('calendar','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Deposit Calendar</span>
              <span class="c1-psel-sub-hint">Deposit activity by day</span>
              <svg v-if="c1PanelActiveContent === 'calendar'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
              Viki
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'viki' }" @click.stop="c1SelectPanel('viki','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Viki — Broker Intelligence</span>
              <span class="c1-psel-sub-hint">Notifications, sync status</span>
              <svg v-if="c1PanelActiveContent === 'viki'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
          </div><!-- end v-else panels -->
        </div>

        <!-- SCREEN 1: CONTENT -->
        <div class="c1-panel-screen">
          <div class="c1-panel-hdr-bar">
            <div class="c1-panel-back-btn" @click="c1SlideOpen = 'nav'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            </div>
            <span class="c1-panel-hdr-ttl">{{ c1ActivePanelLabel }}</span>
            <div class="c1-panel-back-btn" @click="c1SlideOpen = null">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
          <div class="c1-sl-body">

            <!-- ===== FILTERS CONTENT ===== -->
            <template v-if="c1PanelActiveContent === 'filters'">
              <div v-if="b1ActiveFilterCount" class="c1-reset-bar" @click="b1ResetFilters()">
                <svg viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
                Reset all filters
                <span class="c1-reset-bar-count">{{ b1ActiveFilterCount }}</span>
              </div>
              <div class="c1-sl-body">
        <!-- Status -->
        <div class="c1-fp-group">
          <div class="c1-fp-lbl">Status</div>
          <div class="c1-fp-opts">
            <div class="c1-fp-opt" :class="{ on: b1Filters.active === null }" @click="b1Filters.active = null; b1Load()">All</div>
            <div class="c1-fp-opt" :class="{ on: b1Filters.active === true }" @click="b1Filters.active = true; b1Load()">Active</div>
            <div class="c1-fp-opt" :class="{ on: b1Filters.active === false }" @click="b1Filters.active = false; b1Load()">Inactive</div>
          </div>
        </div>
        <!-- Regulated -->
        <div class="c1-fp-group">
          <div class="c1-fp-lbl">Regulated</div>
          <div class="c1-fp-opts">
            <div class="c1-fp-opt" :class="{ on: b1Filters.regulated === null }" @click="b1Filters.regulated = null; b1Load()">All</div>
            <div class="c1-fp-opt b1-chip-reg" :class="{ on: b1Filters.regulated === true }" @click="b1Filters.regulated = true; b1Load()">Regulated</div>
            <div class="c1-fp-opt b1-chip-unreg" :class="{ on: b1Filters.regulated === false }" @click="b1Filters.regulated = false; b1Load()">Not Regulated</div>
          </div>
        </div>
        <!-- Count Twice -->
        <div class="c1-fp-group">
          <div class="c1-fp-lbl">Count Twice</div>
          <div class="c1-fp-opts">
            <div class="c1-fp-opt" :class="{ on: b1Filters.count_twice === null }" @click="b1Filters.count_twice = null; b1Load()">All</div>
            <div class="c1-fp-opt b1-chip-ct" :class="{ on: b1Filters.count_twice === true }" @click="b1Filters.count_twice = true; b1Load()">Count Twice</div>
            <div class="c1-fp-opt" :class="{ on: b1Filters.count_twice === false }" @click="b1Filters.count_twice = false; b1Load()">Normal</div>
          </div>
        </div>
        <!-- Min Deposit Range -->
        <div class="c1-fp-group c1-fp-full">
          <div class="c1-fp-lbl">Min Deposit Range ($)</div>
          <div class="b1-range-row">
            <input class="b1-range-input" type="number" v-model.number="b1Filters.minDepositMin" placeholder="From" min="0" @change="b1Load()" />
            <span class="b1-range-sep">—</span>
            <input class="b1-range-input" type="number" v-model.number="b1Filters.minDepositMax" placeholder="To" min="0" @change="b1Load()" />
          </div>
        </div>
        <!-- Search -->
        <div class="c1-fp-group c1-fp-full">
          <div class="c1-fp-lbl">Search</div>
          <div class="c1-fp-search">
            <svg class="c1-fp-sico" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input class="c1-fp-sinput" v-model.trim="b1Filters.search" placeholder="Broker name…" type="text" @input="b1Load()" />
            <div v-if="b1Filters.search" class="c1-fp-sclear" @click="b1Filters.search = ''; b1Load()">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
        </div>
        <!-- Sort -->
        <div class="c1-fp-group c1-fp-full">
          <div class="c1-fp-lbl">Sort by</div>
          <div class="c1-fp-opts">
            <div class="c1-fp-opt" :class="{ on: b1Sort === 'name_asc' }" @click="b1Sort = 'name_asc'">Name A→Z</div>
            <div class="c1-fp-opt" :class="{ on: b1Sort === 'name_desc' }" @click="b1Sort = 'name_desc'">Name Z→A</div>
            <div class="c1-fp-opt" :class="{ on: b1Sort === 'cpa_desc' }" @click="b1Sort = 'cpa_desc'">CPA ↓</div>
            <div class="c1-fp-opt" :class="{ on: b1Sort === 'dep_desc' }" @click="b1Sort = 'dep_desc'">Deposits ↓</div>
            <div class="c1-fp-opt" :class="{ on: b1Sort === 'start_asc' }" @click="b1Sort = 'start_asc'">Oldest First</div>
            <div class="c1-fp-opt" :class="{ on: b1Sort === 'min_dep_desc' }" @click="b1Sort = 'min_dep_desc'">Min Dep ↓</div>
          </div>
        </div>
              </div>
            </template>

            <!-- ===== CHARTS CONTENT ===== -->
            <template v-if="c1PanelActiveContent === 'charts'">
              <div class="c1-sl-body">
        <!-- KPIs -->
        <div class="c1-fp-group c1-fp-full" style="padding:0">
          <div class="c1-co-lbl">Overview</div>
          <div class="c1-kpi-row">
            <div class="c1-kpi">
              <div class="c1-kpi-lbl">Total Brokers</div>
              <div class="c1-kpi-val">{{ b1Stats.total }}</div>
            </div>
            <div class="c1-kpi">
              <div class="c1-kpi-lbl">Active</div>
              <div class="c1-kpi-val" style="color:#6366f1">{{ b1Stats.active }}</div>
            </div>
            <div class="c1-kpi">
              <div class="c1-kpi-lbl">Deposits / mo</div>
              <div class="c1-kpi-val" style="color:#22c55e">{{ b1Stats.depositsThisMonth }}</div>
            </div>
            <div class="c1-kpi">
              <div class="c1-kpi-lbl">Avg CPA</div>
              <div class="c1-kpi-val" style="color:#f59e0b">${{ b1Stats.avgCpa }}</div>
            </div>
          </div>
        </div>

        <!-- Deposits per broker horizontal bar -->
        <div class="c1-fp-group c1-fp-full" style="padding:0">
          <div class="c1-co-lbl">Deposits per Broker (top 10)</div>
          <div class="c1-vbar-chart">
            <div v-for="bar in b1DepBarData" :key="'dep-'+bar.name" class="c1-vbar-row">
              <div class="c1-vbar-lbl b1-vbar-lbl-broker">{{ bar.shortName }}</div>
              <div class="c1-vbar-track">
                <div class="c1-vbar-fill b1-bar-fill" :style="{ width: bar.pct + '%' }">
                  <span class="c1-vbar-val">{{ bar.val }}</span>
                </div>
              </div>
            </div>
            <div v-if="b1DepBarData.length === 0" class="b1-chart-empty">No data</div>
          </div>
        </div>

        <!-- CPA comparison -->
        <div class="c1-fp-group c1-fp-full" style="padding:0">
          <div class="c1-co-lbl">CPA Comparison (top 10)</div>
          <div class="c1-vbar-chart">
            <div v-for="bar in b1CpaBarData" :key="'cpa-'+bar.name" class="c1-vbar-row">
              <div class="c1-vbar-lbl b1-vbar-lbl-broker">{{ bar.shortName }}</div>
              <div class="c1-vbar-track">
                <div class="c1-vbar-fill b1-bar-fill-cpa" :style="{ width: bar.pct + '%' }">
                  <span class="c1-vbar-val">${{ bar.val }}</span>
                </div>
              </div>
            </div>
            <div v-if="b1CpaBarData.length === 0" class="b1-chart-empty">No data</div>
          </div>
        </div>

        <!-- Deposit sub-status pipeline summary across all brokers -->
        <div class="c1-fp-group c1-fp-full" style="padding:0">
          <div class="c1-co-lbl">Global Deposit Pipeline</div>
          <div class="b1-pipeline-summary">
            <div
              v-for="stage in b1PipelineStages"
              :key="stage.key"
              class="b1-ps-item"
              :style="{ '--ps-clr': stage.color }"
            >
              <div class="b1-ps-num">{{ b1GlobalPipeline[stage.key] || 0 }}</div>
              <div class="b1-ps-lbl">{{ stage.short }}</div>
            </div>
          </div>
        </div>

        <!-- Count twice impact -->
        <div class="c1-fp-group c1-fp-full" style="padding:0">
          <div class="c1-co-lbl">Count Twice Impact</div>
          <div class="b1-ct-impact-wrap">
            <div class="b1-ct-item">
              <div class="b1-ct-num">{{ b1Stats.countTwiceCount }}</div>
              <div class="b1-ct-lbl">Brokers with CT</div>
            </div>
            <div class="b1-ct-item">
              <div class="b1-ct-num b1-ct-num-orange">x2</div>
              <div class="b1-ct-lbl">deposits counted</div>
            </div>
            <div class="b1-ct-item">
              <div class="b1-ct-num b1-ct-num-green">{{ b1Stats.ctDepositBoost }}</div>
              <div class="b1-ct-lbl">effective deposits</div>
            </div>
          </div>
        </div>
              </div>
            </template>

            <!-- ===== CALENDAR CONTENT ===== -->
            <template v-if="c1PanelActiveContent === 'calendar'">
              <div class="c1-sl-body">
      <!-- Broker filter -->
      <div class="b1-cal-broker-row">
        <div class="b1-cal-broker-lbl">Broker:</div>
        <select class="b1-cal-broker-sel" v-model="b1CalBroker" @change="b1CalBrokerChanged()">
          <option :value="null">— All brokers —</option>
          <option v-for="b in b1Brokers" :key="b.id" :value="b.id">{{ b.name }}</option>
        </select>
      </div>
      <!-- Month nav -->
      <div class="b1-cal-nav">
        <button class="b1-cal-nav-btn" @click="b1CalPrev()">
          <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <span class="b1-cal-month-lbl">{{ b1CalMonthNames[b1Cal.month] }} {{ b1Cal.year }}</span>
        <button class="b1-cal-nav-btn" @click="b1CalNext()">
          <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      </div>
      <!-- Calendar grid -->
      <div class="b1-cal-grid-wrap">
        <div class="b1-cal-grid">
          <div v-for="dh in ['M','T','W','T','F','S','S']" :key="'dh'+dh+Math.random()" class="b1-cal-dh">{{ dh }}</div>
          <template v-for="(week, wi) in b1CalGrid">
            <div
              v-for="cell in week"
              :key="wi + '-' + cell.date"
              class="b1-cal-cell"
              :class="{
                'b1-cal-other': !cell.inMonth,
                'b1-cal-today': cell.today,
                'b1-cal-has': cell.count > 0,
                'b1-cal-sel': b1CalSelected === cell.date
              }"
              @click="cell.inMonth && b1CalSelectDay(cell.date)"
            >
              <span class="b1-cal-day-num">{{ cell.day }}</span>
              <span v-if="cell.count > 0" class="b1-cal-dot">{{ cell.count }}</span>
              <!-- broker color dots -->
              <div v-if="cell.brokerDots && cell.brokerDots.length" class="b1-cal-bdots">
                <span
                  v-for="dot in cell.brokerDots.slice(0,4)"
                  :key="dot.id"
                  class="b1-cal-bdot"
                  :style="{ background: dot.color }"
                  :title="dot.name"
                ></span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <!-- Day breakdown by broker -->
      <div v-if="b1CalSelected" class="b1-cal-day-list">
        <div class="b1-cal-day-hdr">
          Deposits on {{ b1CalSelected }}
          <span class="b1-cal-day-count">{{ b1CalDayDeposits.length }}</span>
        </div>
        <div v-if="b1CalDayDeposits.length === 0" class="b1-cal-day-empty">No deposits on this day</div>
        <!-- Group by broker -->
        <div v-for="grp in b1CalDayByBroker" :key="'grp-'+grp.brokerId" class="b1-cal-broker-grp">
          <div class="b1-cal-grp-hdr">
            <span class="b1-cal-grp-dot" :style="{ background: grp.color }"></span>
            <span class="b1-cal-grp-name">{{ grp.brokerName }}</span>
            <span class="b1-cal-grp-cnt">{{ grp.deposits.length }}</span>
          </div>
          <div v-for="dep in grp.deposits" :key="'cday-'+dep.id" class="b1-cal-dep-row">
            <div class="b1-cal-dep-body">
              <span class="b1-cal-dep-client">{{ dep.client_name || ('Client #' + dep.client_id) }}</span>
              <span class="b1-cal-dep-country">{{ dep.country || '' }}</span>
              <span class="b1-cal-dep-amt">${{ dep.amount || '—' }}</span>
            </div>
            <div class="b1-cal-dep-status" :class="'b1-ss-' + b1SsKey(dep.sub_status)">{{ dep.sub_status || '—' }}</div>
          </div>
        </div>
              </div>
            </template>

            <!-- ===== VIKI CONTENT ===== -->
            <template v-if="c1PanelActiveContent === 'viki'">
              <div class="b1-viki-mark-all" @click="b1MarkAllVikiRead()" style="padding:8px 14px 0;cursor:pointer;font-size:12px;color:var(--c1-sc)">Mark all read</div>
      <!-- Sync status bar -->
      <div class="b1-sync-bar">
        <div class="b1-sync-dot" :class="{ active: b1SyncActive }"></div>
        <span class="b1-sync-lbl">Broker cron sync:</span>
        <span class="b1-sync-time">{{ b1LastSyncLabel }}</span>
        <div class="c1-hp"></div>
        <button class="b1-sync-btn" @click="b1ManualSync()" :disabled="b1SyncActive">
          <svg viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
          Sync now
        </button>
      </div>
      <!-- Notifications list -->
      <div class="b1-viki-list">
        <div v-if="b1VikiNotifs.length === 0" class="b1-viki-empty">
          <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          <span>All quiet — no new broker events</span>
        </div>
        <div
          v-for="notif in b1VikiNotifs"
          :key="notif.id"
          class="b1-viki-item"
          :class="{ 'b1-viki-unread': !notif.read, 'b1-viki-alert': notif.type === 'alert' }"
          @click="b1VikiRead(notif)"
        >
          <div class="b1-viki-icon" :class="'b1-viki-icon-' + notif.type">
            <svg v-if="notif.type === 'deposit'" viewBox="0 0 24 24"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
            <svg v-else-if="notif.type === 'alert'" viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
            <svg v-else viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          </div>
          <div class="b1-viki-body">
            <div class="b1-viki-msg">{{ notif.msg }}</div>
            <div class="b1-viki-meta">{{ notif.time }}</div>
          </div>
          <div v-if="!notif.read" class="b1-viki-unread-dot"></div>
        </div>
            </template>

          </div>
        </div>

      </div>
    </div>

    <!-- SUMMARY BAR -->
    <div class="b1-summary-bar">
      <div class="b1-sb-item">
        <div class="b1-sb-val">{{ b1Stats.total }}</div>
        <div class="b1-sb-lbl">Total</div>
      </div>
      <div class="b1-sb-sep"></div>
      <div class="b1-sb-item">
        <div class="b1-sb-val b1-sb-active">{{ b1Stats.active }}</div>
        <div class="b1-sb-lbl">Active</div>
      </div>
      <div class="b1-sb-sep"></div>
      <div class="b1-sb-item">
        <div class="b1-sb-val b1-sb-dep">{{ b1Stats.depositsThisMonth }}</div>
        <div class="b1-sb-lbl">Deposits</div>
      </div>
      <div class="b1-sb-sep"></div>
      <div class="b1-sb-item">
        <div class="b1-sb-val b1-sb-cpa">${{ b1Stats.avgCpa }}</div>
        <div class="b1-sb-lbl">Avg CPA</div>
      </div>
      <div class="b1-sb-sep"></div>
      <!-- Cron sync status -->
      <div class="b1-sb-item b1-sb-sync" @click="c1SelectPanel('viki','')">
        <div class="b1-sb-sync-dot" :class="{ active: b1SyncActive }"></div>
        <div class="b1-sb-lbl">{{ b1LastSyncLabel }}</div>
      </div>
      <div class="c1-hp"></div>
      <button class="b1-add-btn" @click="b1OpenAddDrawer()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
        Add Broker
      </button>
    </div>

    <!-- BROKER LIST -->
    <div class="b1-list" v-if="!b1Loading">

      <!-- Empty state -->
      <div v-if="b1BrokersFiltered.length === 0" class="b1-empty">
        <div class="b1-empty-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
        </div>
        <div class="b1-empty-msg">No brokers found</div>
        <button class="b1-empty-cta" @click="b1ResetFilters()">Clear filters</button>
      </div>

      <!-- Broker accordion rows -->
      <div
        v-for="broker in b1BrokersFiltered"
        :key="broker.id"
        class="b1-box"
        :class="{ 'b1-box-expanded': b1Expanded === broker.id, 'b1-box-inactive': !broker.active }"
      >
        <!-- Collapsed header row -->
        <div class="b1-box-row" @click="b1ToggleExpand(broker.id)">
          <div class="b1-accent" :style="{ background: b1BrokerColor(broker) }"></div>
          <!-- Avatar / initials (logo placeholder) -->
          <div class="b1-av" :style="{ background: b1BrokerColor(broker) }">
            {{ b1Initials(broker.name) }}
          </div>
          <!-- Main info -->
          <div class="b1-box-info">
            <div class="b1-box-name">
              {{ broker.name }}
              <svg class="b1-chv" :class="{ open: b1Expanded === broker.id }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
            <div class="b1-box-meta">
              <span v-if="broker.regulated" class="b1-chip b1-chip-reg">Reg</span>
              <span v-else class="b1-chip b1-chip-unreg">Unreg</span>
              <span v-if="broker.count_twice" class="b1-chip b1-chip-ct">x2</span>
              <span class="b1-meta-sep">·</span>
              <span class="b1-meta-txt">{{ broker.orders_amount || 0 }} dep</span>
              <span class="b1-meta-sep">·</span>
              <span class="b1-meta-txt b1-meta-cpa">CPA ${{ broker.avg_cpa || 0 }}</span>
              <span v-if="broker.last_deposit_date" class="b1-meta-sep">·</span>
              <span v-if="broker.last_deposit_date" class="b1-meta-txt b1-meta-dim">Last: {{ b1FmtDate(broker.last_deposit_date) }}</span>
            </div>
          </div>
          <!-- Status badge -->
          <div class="b1-status-badge" :class="broker.active ? 'b1-badge-active' : 'b1-badge-inactive'">
            {{ broker.active ? 'Active' : 'Inactive' }}
          </div>
          <!-- Open detail drawer -->
          <button class="b1-detail-btn" @click.stop="b1OpenDetail(broker)" title="Full profile">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>
          </button>
        </div>

        <!-- Expanded inline details -->
        <div v-if="b1Expanded === broker.id" class="b1-box-detail">
          <!-- Quick fields -->
          <div class="b1-detail-grid">
            <div class="b1-df">
              <div class="b1-df-l">Contact Name</div>
              <div class="b1-df-v">{{ broker.contact_name || '—' }}</div>
            </div>
            <div class="b1-df">
              <div class="b1-df-l">Skype</div>
              <div class="b1-df-v b1-mono">{{ broker.contact_skype || '—' }}</div>
            </div>
            <div class="b1-df">
              <div class="b1-df-l">Min Deposit</div>
              <div class="b1-df-v b1-val-accent">${{ broker.min_deposit || 0 }}</div>
            </div>
            <div class="b1-df">
              <div class="b1-df-l">Orders Amount</div>
              <div class="b1-df-v">{{ broker.orders_amount || 0 }}</div>
            </div>
            <div class="b1-df">
              <div class="b1-df-l">Start Date</div>
              <div class="b1-df-v b1-mono">{{ b1FmtDate(broker.start_date) }}</div>
            </div>
            <div class="b1-df">
              <div class="b1-df-l">Count Twice</div>
              <div class="b1-df-v">
                <span v-if="broker.count_twice" class="b1-chip b1-chip-ct">Enabled</span>
                <span v-else class="b1-chip-off">Disabled</span>
              </div>
            </div>
          </div>

          <!-- Deposit sub-status pipeline for this broker -->
          <div class="b1-pipeline-wrap">
            <div class="b1-pipeline-lbl">Deposit Pipeline</div>
            <div class="b1-pipeline-row">
              <div
                v-for="stage in b1PipelineStages"
                :key="'ps-'+broker.id+stage.key"
                class="b1-pipe-stage"
                :style="{ '--ps-clr': stage.color }"
                :title="stage.label"
              >
                <div class="b1-pipe-num">{{ (broker.pipeline && broker.pipeline[stage.key]) || 0 }}</div>
                <div class="b1-pipe-lbl">{{ stage.short }}</div>
              </div>
            </div>
          </div>

          <div class="b1-box-actions">
            <button class="b1-act-btn b1-act-detail" @click="b1OpenDetail(broker)">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
              View Full Profile
            </button>
            <button class="b1-act-btn b1-act-edit" @click="b1OpenEditDrawer(broker)">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
              Edit
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading state -->
    <div v-else class="b1-loading">
      <div class="c1-spinner"></div>
      <div class="b1-loading-txt">Loading brokers…</div>
    </div>

    <!-- =========================================================
         RIGHT DRAWER: Broker Detail (slides from right)
         ========================================================= -->
    <transition name="b1-drawer">
      <div v-if="b1DetailOpen && b1DetailBroker" class="b1-drawer-wrap" @click.self="b1DetailOpen = false">
        <div class="b1-drawer">
          <div class="b1-drawer-head">
            <div class="b1-drawer-av" :style="{ background: b1BrokerColor(b1DetailBroker) }">
              {{ b1Initials(b1DetailBroker.name) }}
            </div>
            <div class="b1-drawer-title">
              <div class="b1-drawer-name">{{ b1DetailBroker.name }}</div>
              <div class="b1-drawer-sub">
                <span v-if="b1DetailBroker.regulated" class="b1-chip b1-chip-reg">Regulated</span>
                <span v-else class="b1-chip b1-chip-unreg">Unregulated</span>
                <span v-if="b1DetailBroker.active" class="b1-chip b1-chip-active" style="margin-left:4px">Active</span>
                <span v-else class="b1-chip" style="background:rgba(255,255,255,.05);color:#888;margin-left:4px">Inactive</span>
              </div>
            </div>
            <button class="b1-drawer-close" @click="b1DetailOpen = false">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>

          <!-- Drawer tab bar -->
          <div class="b1-dtab-bar">
            <div class="b1-dtab" :class="{ on: b1DetailTab === 'profile' }" @click="b1DetailTab = 'profile'">Profile</div>
            <div class="b1-dtab" :class="{ on: b1DetailTab === 'deposits' }" @click="b1DetailTab = 'deposits'">Deposits</div>
            <div class="b1-dtab" :class="{ on: b1DetailTab === 'pipeline' }" @click="b1DetailTab = 'pipeline'">Pipeline</div>
            <div class="b1-dtab" :class="{ on: b1DetailTab === 'agents' }" @click="b1DetailTab = 'agents'">Agents</div>
          </div>

          <div class="b1-drawer-body">

            <!-- ── TAB: PROFILE ── -->
            <template v-if="b1DetailTab === 'profile'">
              <div class="b1-exp-sec">
                <div class="b1-exp-lbl">Broker Profile</div>
                <div class="b1-exp-grid">
                  <div class="b1-exp-field">
                    <div class="b1-exp-fl">Contact Name</div>
                    <div class="b1-exp-fv">{{ b1DetailBroker.contact_name || '—' }}</div>
                  </div>
                  <div class="b1-exp-field">
                    <div class="b1-exp-fl">Skype</div>
                    <div class="b1-exp-fv b1-mono">{{ b1DetailBroker.contact_skype || '—' }}</div>
                  </div>
                  <div class="b1-exp-field">
                    <div class="b1-exp-fl">Min Deposit</div>
                    <div class="b1-exp-fv b1-val-accent">${{ b1DetailBroker.min_deposit || 0 }}</div>
                  </div>
                  <div class="b1-exp-field">
                    <div class="b1-exp-fl">Avg CPA</div>
                    <div class="b1-exp-fv b1-val-cpa">${{ b1DetailBroker.avg_cpa || 0 }}</div>
                  </div>
                  <div class="b1-exp-field">
                    <div class="b1-exp-fl">Start Date</div>
                    <div class="b1-exp-fv b1-mono">{{ b1FmtDate(b1DetailBroker.start_date) }}</div>
                  </div>
                  <div class="b1-exp-field">
                    <div class="b1-exp-fl">Orders Amount</div>
                    <div class="b1-exp-fv">{{ b1DetailBroker.orders_amount || 0 }}</div>
                  </div>
                  <div class="b1-exp-field b1-exp-full">
                    <div class="b1-exp-fl">Count Twice</div>
                    <div class="b1-exp-fv">
                      <span v-if="b1DetailBroker.count_twice" class="b1-chip b1-chip-ct">Enabled — deposits counted x2</span>
                      <span v-else style="color:#888">Disabled</span>
                    </div>
                  </div>
                  <div class="b1-exp-field b1-exp-full">
                    <div class="b1-exp-fl">Deposit Methods</div>
                    <div class="b1-exp-fv">{{ b1DetailBroker.deposit_methods || b1DetailBroker.payment_methods || '—' }}</div>
                  </div>
                </div>
              </div>

              <!-- Scheduled call button -->
              <div class="b1-exp-sec">
                <div class="b1-exp-lbl">Actions</div>
                <div class="b1-detail-actions">
                  <button class="b1-sched-btn" @click="b1ScheduleCall(b1DetailBroker)">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                    Schedule Call to Broker
                  </button>
                  <button class="b1-act-btn b1-act-edit" @click="b1OpenEditDrawer(b1DetailBroker); b1DetailOpen = false">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                    Edit Broker
                  </button>
                  <button class="b1-act-btn b1-act-danger" @click="b1ToggleBrokerActive(b1DetailBroker)">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>
                    {{ b1DetailBroker.active ? 'Set Inactive' : 'Set Active' }}
                  </button>
                </div>
              </div>

              <!-- Monthly trend chart -->
              <div class="b1-exp-sec">
                <div class="b1-exp-lbl">Monthly Trend</div>
                <div class="c1-vbar-chart b1-monthly-chart">
                  <div v-for="bar in b1DetailMonthly" :key="bar.label" class="c1-vbar-row">
                    <div class="c1-vbar-lbl" style="width:46px;font-size:9px">{{ bar.label }}</div>
                    <div class="c1-vbar-track">
                      <div class="c1-vbar-fill b1-bar-fill" :style="{ width: bar.pct + '%' }">
                        <span class="c1-vbar-val">{{ bar.val }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="b1DetailMonthly.length === 0 && !b1DetailLoadingDeps" class="b1-chart-empty">No monthly data</div>
                  <div v-if="b1DetailLoadingDeps" class="b1-exp-loading"><div class="c1-spinner c1-spinner-sm"></div></div>
                </div>
              </div>

              <!-- Assigned clients -->
              <div class="b1-exp-sec">
                <div class="b1-exp-lbl">Assigned Clients</div>
                <div v-if="b1DetailLoadingClients" class="b1-exp-loading"><div class="c1-spinner c1-spinner-sm"></div></div>
                <div v-if="!b1DetailLoadingClients && b1DetailClients.length === 0" class="b1-exp-empty">No clients found</div>
                <div v-for="client in b1DetailClients.slice(0, 20)" :key="'det-cl-'+client.id" class="b1-act-row">
                  <div class="b1-act-av">{{ b1ClientInitials(client) }}</div>
                  <div class="b1-act-body">
                    <span class="b1-act-main">{{ client.first_name }} {{ client.last_name }}</span>
                    <span class="b1-act-meta">#{{ client.id }} · {{ client.country || '' }}</span>
                  </div>
                  <div class="b1-act-date b1-mono">{{ b1FmtDate(client.created_at) }}</div>
                </div>
                <div v-if="b1DetailClients.length > 20" class="b1-exp-more">+{{ b1DetailClients.length - 20 }} more</div>
              </div>
            </template>

            <!-- ── TAB: DEPOSITS ── -->
            <template v-if="b1DetailTab === 'deposits'">
              <div class="b1-exp-sec">
                <div class="b1-exp-lbl">Deposit History</div>
                <!-- Date range quick filter -->
                <div class="b1-dep-range-row">
                  <div
                    v-for="p in b1DepRangePills"
                    :key="p.k"
                    class="b1-dep-range-pill"
                    :class="{ on: b1DepRange === p.k }"
                    @click="b1DepRange = p.k; b1LoadDetailDeposits(b1DetailBroker)"
                  >{{ p.l }}</div>
                </div>
                <div v-if="b1DetailLoadingDeps" class="b1-exp-loading"><div class="c1-spinner c1-spinner-sm"></div></div>
                <div v-if="!b1DetailLoadingDeps && b1DetailDeposits.length === 0" class="b1-exp-empty">No deposits found</div>
                <!-- Deposit table -->
                <div v-if="b1DetailDeposits.length > 0" class="b1-dep-table">
                  <div class="b1-dep-thead">
                    <span>Date</span><span>Client</span><span>Amount</span><span>Sub-Status</span>
                  </div>
                  <div v-for="dep in b1DetailDeposits" :key="'det-dep-'+dep.id" class="b1-dep-trow">
                    <span class="b1-mono">{{ b1FmtDate(dep.created_at) }}</span>
                    <span>{{ dep.client_name || ('#' + dep.client_id) }}</span>
                    <span class="b1-val-green">${{ dep.amount || '—' }}</span>
                    <span class="b1-dep-ss" :class="'b1-ss-' + b1SsKey(dep.sub_status)">{{ dep.sub_status || '—' }}</span>
                  </div>
                </div>
                <div v-if="b1DetailDeposits.length >= 50" class="b1-exp-more">Showing last 50 deposits</div>
              </div>
            </template>

            <!-- ── TAB: PIPELINE ── -->
            <template v-if="b1DetailTab === 'pipeline'">
              <div class="b1-exp-sec">
                <div class="b1-exp-lbl">Deposit Sub-Status Flow</div>
                <div class="b1-pipeline-detail">
                  <div
                    v-for="(stage, idx) in b1PipelineStages"
                    :key="'det-ps-'+stage.key"
                    class="b1-pd-stage"
                    :style="{ '--ps-clr': stage.color }"
                  >
                    <div class="b1-pd-num">{{ (b1DetailBroker.pipeline && b1DetailBroker.pipeline[stage.key]) || 0 }}</div>
                    <div class="b1-pd-lbl">{{ stage.label }}</div>
                    <div v-if="idx < b1PipelineStages.length - 1" class="b1-pd-arrow">→</div>
                  </div>
                </div>
                <!-- Conversion rate -->
                <div class="b1-conv-rate">
                  <div class="b1-conv-lbl">Check → Done rate</div>
                  <div class="b1-conv-val">{{ b1DetailConvRate }}%</div>
                </div>
              </div>

              <!-- Status distribution bar -->
              <div class="b1-exp-sec">
                <div class="b1-exp-lbl">Status Distribution</div>
                <div class="b1-status-dist">
                  <div
                    v-for="stage in b1PipelineStages"
                    :key="'dist-'+stage.key"
                    class="b1-dist-row"
                  >
                    <div class="b1-dist-lbl">{{ stage.short }}</div>
                    <div class="b1-dist-track">
                      <div
                        class="b1-dist-fill"
                        :style="{
                          width: b1DistPct(stage.key) + '%',
                          background: stage.color
                        }"
                      ></div>
                    </div>
                    <div class="b1-dist-val" :style="{ color: stage.color }">{{ (b1DetailBroker.pipeline && b1DetailBroker.pipeline[stage.key]) || 0 }}</div>
                  </div>
                </div>
              </div>
            </template>

            <!-- ── TAB: AGENTS ── -->
            <template v-if="b1DetailTab === 'agents'">
              <div class="b1-exp-sec">
                <div class="b1-exp-lbl">Top Agents Depositing with {{ b1DetailBroker.name }}</div>
                <div v-if="b1DetailLoadingAgents" class="b1-exp-loading"><div class="c1-spinner c1-spinner-sm"></div></div>
                <div v-if="!b1DetailLoadingAgents && b1DetailAgents.length === 0" class="b1-exp-empty">No agent data found</div>
                <div v-for="agent in b1DetailAgents" :key="'ag-'+agent.id" class="b1-agent-row">
                  <div class="b1-agent-av" :style="{ background: b1AgentColor(agent.id) }">{{ b1AgentInitials(agent) }}</div>
                  <div class="b1-agent-info">
                    <div class="b1-agent-name">{{ agent.first_name }} {{ agent.last_name }}</div>
                    <div class="b1-agent-role">{{ b1RoleFromId(agent.role) }}</div>
                  </div>
                  <div class="b1-agent-stats">
                    <div class="b1-agent-dep-count">{{ agent.deposit_count || 0 }} dep</div>
                    <div class="b1-agent-bar-wrap">
                      <div class="b1-agent-bar" :style="{ width: b1AgentBarPct(agent) + '%', background: b1AgentColor(agent.id) }"></div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Agent-to-broker deposit matrix (mini) -->
              <div v-if="b1DetailAgents.length > 0" class="b1-exp-sec">
                <div class="b1-exp-lbl">Deposit Share by Agent</div>
                <div class="b1-agent-donut-wrap">
                  <div v-for="agent in b1DetailAgents.slice(0,6)" :key="'ad-'+agent.id" class="b1-agent-share-row">
                    <span class="b1-agent-share-dot" :style="{ background: b1AgentColor(agent.id) }"></span>
                    <span class="b1-agent-share-name">{{ agent.first_name }}</span>
                    <div class="b1-agent-share-track">
                      <div class="b1-agent-share-fill" :style="{ width: b1AgentBarPct(agent) + '%', background: b1AgentColor(agent.id) }"></div>
                    </div>
                    <span class="b1-agent-share-pct">{{ b1AgentBarPct(agent) }}%</span>
                  </div>
                </div>
              </div>
            </template>

          </div><!-- /b1-drawer-body -->
        </div><!-- /b1-drawer -->
      </div><!-- /b1-drawer-wrap -->
    </transition>

    <!-- =========================================================
         LEFT DRAWER: Add / Edit Broker (slides from left)
         ========================================================= -->
    <transition name="b1-drawer-left">
      <div v-if="b1AddOpen" class="b1-drawer-wrap b1-drawer-wrap-left" @click.self="b1AddOpen = false">
        <div class="b1-drawer b1-drawer-left">
          <div class="b1-drawer-head">
            <div class="b1-drawer-title">
              <div class="b1-drawer-name">{{ b1EditMode ? 'Edit Broker' : 'Add New Broker' }}</div>
              <div class="b1-drawer-sub">{{ b1EditMode ? 'Update broker details' : 'Quick setup' }}</div>
            </div>
            <button class="b1-drawer-close" @click="b1AddOpen = false">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <div class="b1-drawer-body">
            <form class="b1-add-form" @submit.prevent="b1SubmitAdd()">

              <div class="b1-form-group">
                <label class="b1-form-lbl">Broker Name <span class="b1-req">*</span></label>
                <input class="b1-form-input" v-model.trim="b1AddForm.name" placeholder="e.g. TradePros EU" required />
              </div>

              <div class="b1-form-row-2">
                <div class="b1-form-group">
                  <label class="b1-form-lbl">Min Deposit ($)</label>
                  <input class="b1-form-input" v-model.number="b1AddForm.min_deposit" type="number" placeholder="250" min="0" />
                </div>
                <div class="b1-form-group">
                  <label class="b1-form-lbl">Avg CPA ($)</label>
                  <input class="b1-form-input" v-model.number="b1AddForm.avg_cpa" type="number" placeholder="300" min="0" />
                </div>
              </div>

              <div class="b1-form-group">
                <label class="b1-form-lbl">Contact Name</label>
                <input class="b1-form-input" v-model.trim="b1AddForm.contact_name" placeholder="John Smith" />
              </div>

              <div class="b1-form-group">
                <label class="b1-form-lbl">Contact Skype</label>
                <input class="b1-form-input b1-mono" v-model.trim="b1AddForm.contact_skype" placeholder="live:johnsmith" />
              </div>

              <div class="b1-form-group">
                <label class="b1-form-lbl">Deposit Methods</label>
                <input class="b1-form-input" v-model.trim="b1AddForm.deposit_methods" placeholder="Credit Card, Wire, Crypto" />
              </div>

              <div class="b1-form-row-2">
                <div class="b1-form-group">
                  <label class="b1-form-lbl">Regulated</label>
                  <div class="b1-toggle-row">
                    <button type="button" class="b1-toggle-btn" :class="{ on: b1AddForm.regulated }" @click="b1AddForm.regulated = !b1AddForm.regulated">
                      <div class="b1-toggle-dot"></div>
                    </button>
                    <span class="b1-toggle-lbl">{{ b1AddForm.regulated ? 'Yes' : 'No' }}</span>
                  </div>
                </div>
                <div class="b1-form-group">
                  <label class="b1-form-lbl">Count Twice</label>
                  <div class="b1-toggle-row">
                    <button type="button" class="b1-toggle-btn" :class="{ on: b1AddForm.count_twice }" @click="b1AddForm.count_twice = !b1AddForm.count_twice">
                      <div class="b1-toggle-dot"></div>
                    </button>
                    <span class="b1-toggle-lbl">{{ b1AddForm.count_twice ? 'Enabled' : 'Disabled' }}</span>
                  </div>
                </div>
              </div>

              <div class="b1-form-row-2">
                <div class="b1-form-group">
                  <label class="b1-form-lbl">Active</label>
                  <div class="b1-toggle-row">
                    <button type="button" class="b1-toggle-btn" :class="{ on: b1AddForm.active }" @click="b1AddForm.active = !b1AddForm.active">
                      <div class="b1-toggle-dot"></div>
                    </button>
                    <span class="b1-toggle-lbl">{{ b1AddForm.active ? 'Active' : 'Inactive' }}</span>
                  </div>
                </div>
              </div>

              <div v-if="b1AddError" class="b1-form-error">{{ b1AddError }}</div>
              <div v-if="b1AddSuccess" class="b1-form-success">{{ b1AddSuccess }}</div>

              <button type="submit" class="b1-submit-btn" :disabled="b1AddLoading || !b1AddForm.name">
                <span v-if="b1AddLoading">Saving…</span>
                <span v-else>{{ b1EditMode ? 'Save Changes' : 'Add Broker' }}</span>
              </button>

            </form>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import VikiFace from "../../clients1.feature/VikiFace.vue";
import C1ModCalendar from '../../../components/C1ModCalendar.vue';

const API = '/api';

export default {
  name: 'Brokers1Container',

  components: { VikiFace, C1ModCalendar },

  data() {
    return {
      c1Status: 'shift',
      c1StatusSince: 0,
      c1StatusElapsed: '00:00',
      c1StatusMenuOpen: false,
      _c1StatusInterval: null,
      c1HamMenuOpen: false,
      c1ShiftMenuOpen: false,
      c1TopTab: null,
      c1ShiftElapsed: '00:00',
      c1ShiftStartTime: 0,
      c1BathroomCount: 0,
      c1CoffeeCount: 0,
      c1WeekLog: [],
      // Panel state
      c1NavMode: 'panels',
      c1VikiMood: 'neutral',
      c1VikiSpeaking: false,
      c1SlideOpen: null,
      c1PanelActiveContent: null,
      b1SlideOpen: 'nav',
      b1TimeStr: '',
      b1TimeInterval: null,

      // Brokers list
      b1Brokers: [],
      b1Loading: false,

      // Filters
      b1Filters: {
        active: null,
        regulated: null,
        count_twice: null,
        minDepositMin: null,
        minDepositMax: null,
        search: ''
      },
      b1Sort: 'name_asc',

      // Accordion expand
      b1Expanded: null,

      // Right drawer — detail
      b1DetailOpen: false,
      b1DetailBroker: null,
      b1DetailTab: 'profile',
      b1DetailDeposits: [],
      b1DetailMonthly: [],
      b1DetailClients: [],
      b1DetailAgents: [],
      b1DetailLoadingDeps: false,
      b1DetailLoadingClients: false,
      b1DetailLoadingAgents: false,

      // Deposit range filter in detail drawer
      b1DepRange: '30d',
      b1DepRangePills: [
        { k: '7d', l: '7d' },
        { k: '30d', l: '30d' },
        { k: '90d', l: '90d' },
        { k: 'all', l: 'All' }
      ],

      // Left drawer — add / edit
      b1AddOpen: false,
      b1EditMode: false,
      b1EditBrokerId: null,
      b1AddLoading: false,
      b1AddError: null,
      b1AddSuccess: null,
      b1AddForm: {
        name: '',
        min_deposit: null,
        avg_cpa: null,
        contact_name: '',
        contact_skype: '',
        deposit_methods: '',
        regulated: false,
        count_twice: false,
        active: true
      },

      // Calendar
      b1Cal: {
        year: new Date().getFullYear(),
        month: new Date().getMonth()
      },
      b1CalMonthNames: ['January','February','March','April','May','June','July','August','September','October','November','December'],
      b1CalBroker: null,
      b1CalSelected: null,
      b1CalDeposits: {},  // { 'YYYY-MM-DD': [{id, amount, broker_name, broker_id, client_name, ...}] }

      // Viki
      b1VikiNotifs: [],
      b1VikiUnread: 0,
      b1VikiInterval: null,

      // Cron sync status
      b1LastSyncAt: null,
      b1SyncActive: false,
      b1LastSyncLabel: 'Syncing…',

      // Toast
      b1Toast: null,
      b1ToastTimer: null,

      // Sync interval
      b1SyncInterval: null,

      // Pipeline stages definition
      b1PipelineStages: [
        { key: 'CHECK',         short: 'CHK',  label: 'Check',         color: '#6366f1' },
        { key: 'BROKER_CHECK',  short: 'BCK',  label: 'Broker Check',  color: '#8b5cf6' },
        { key: 'DEPOSIT_IN',    short: 'DIN',  label: 'Deposit In',    color: '#06b6d4' },
        { key: 'DOCUMENTS',     short: 'DOC',  label: 'Documents',     color: '#3b82f6' },
        { key: 'TRADED',        short: 'TRD',  label: 'Traded',        color: '#f59e0b' },
        { key: 'DONE_SALES',    short: 'DS',   label: 'Done Sales',    color: '#22c55e' },
        { key: 'DONE_SUPPORT',  short: 'DSP',  label: 'Done Support',  color: '#10b981' },
        { key: 'BACK_TO_SALES', short: 'BTS',  label: 'Back to Sales', color: '#f97316' },
        { key: 'APPROVED',      short: 'APR',  label: 'Approved',      color: '#84cc16' },
        { key: 'REMOVED',       short: 'REM',  label: 'Removed',       color: '#ef4444' }
      ],

      // Color palette for brokers / agents
      b1Colors: ['#6366f1','#22c55e','#f59e0b','#ef4444','#8b5cf6','#06b6d4','#ec4899','#14b8a6','#f97316','#84cc16'],
      b1AgentColors: ['#4275ec','#ae3ede','#fb9324','#14b8a6','#f43f5e','#a78bfa','#34d399','#fbbf24']
    };
  },

  computed: {
    c1PanelIsOpen() {
      return !!this.c1SlideOpen && this.c1SlideOpen !== 'menu';
    },
    c1PanelAtContent() {
      return this.c1PanelIsOpen && this.c1SlideOpen !== 'nav';
    },
    c1ActivePanelLabel() {
      if (!this.c1PanelIsOpen || this.c1SlideOpen === 'nav') return 'Panels';
      const map = { filters: 'Filters', charts: 'Analytics', calendar: 'Calendar', viki: 'Viki' };
      return (this.c1PanelActiveContent && map[this.c1PanelActiveContent]) || 'Panels';
    },

    b1AuthUser() {
      try { return (this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user) || {}; }
      catch (e) { return {}; }
    },

    b1UserInitials() {
      const u = this.b1AuthUser;
      return (((u.first_name || '')[0] || '').toUpperCase() + ((u.last_name || '')[0] || '').toUpperCase()) || '?';
    },

    b1RoleLabel() {
      const map = { 1:'Admin', 2:'Team Leader', 3:'Manager', 4:'Senior Agent', 5:'Agent', 6:'Junior Agent', 7:'New Agent', 8:'Support', 9:'Retention', 10:'Finance', 12:'Super Admin' };
      return map[this.b1AuthUser && this.b1AuthUser.role] || 'User';
    },

    b1ActiveFilterCount() {
      let n = 0;
      if (this.b1Filters.active !== null) n++;
      if (this.b1Filters.regulated !== null) n++;
      if (this.b1Filters.count_twice !== null) n++;
      if (this.b1Filters.minDepositMin !== null && this.b1Filters.minDepositMin !== '') n++;
      if (this.b1Filters.minDepositMax !== null && this.b1Filters.minDepositMax !== '') n++;
      if (this.b1Filters.search) n++;
      return n;
    },

    b1Stats() {
      const all = this.b1Brokers;
      const total = all.length;
      const active = all.filter(b => b.active).length;
      const depositsThisMonth = all.reduce((s, b) => s + (b.orders_amount || 0), 0);
      const cpaValues = all.filter(b => b.avg_cpa > 0).map(b => b.avg_cpa);
      const avgCpa = cpaValues.length ? Math.round(cpaValues.reduce((s, v) => s + v, 0) / cpaValues.length) : 0;
      const ctBrokers = all.filter(b => b.count_twice);
      const countTwiceCount = ctBrokers.length;
      const ctDepositBoost = all.reduce((s, b) => s + (b.orders_amount || 0) * (b.count_twice ? 2 : 1), 0);
      return { total, active, depositsThisMonth, avgCpa, countTwiceCount, ctDepositBoost };
    },

    b1BrokersFiltered() {
      let list = [...this.b1Brokers];
      if (this.b1Filters.active !== null)
        list = list.filter(b => !!b.active === this.b1Filters.active);
      if (this.b1Filters.regulated !== null)
        list = list.filter(b => !!b.regulated === this.b1Filters.regulated);
      if (this.b1Filters.count_twice !== null)
        list = list.filter(b => !!b.count_twice === this.b1Filters.count_twice);
      if (this.b1Filters.minDepositMin !== null && this.b1Filters.minDepositMin !== '')
        list = list.filter(b => (b.min_deposit || 0) >= this.b1Filters.minDepositMin);
      if (this.b1Filters.minDepositMax !== null && this.b1Filters.minDepositMax !== '')
        list = list.filter(b => (b.min_deposit || 0) <= this.b1Filters.minDepositMax);
      if (this.b1Filters.search) {
        const q = this.b1Filters.search.toLowerCase();
        list = list.filter(b => (b.name || '').toLowerCase().includes(q));
      }
      switch (this.b1Sort) {
        case 'name_asc':     list.sort((a, b) => (a.name || '').localeCompare(b.name || '')); break;
        case 'name_desc':    list.sort((a, b) => (b.name || '').localeCompare(a.name || '')); break;
        case 'cpa_desc':     list.sort((a, b) => (b.avg_cpa || 0) - (a.avg_cpa || 0)); break;
        case 'dep_desc':     list.sort((a, b) => (b.orders_amount || 0) - (a.orders_amount || 0)); break;
        case 'start_asc':    list.sort((a, b) => new Date(a.start_date || 0) - new Date(b.start_date || 0)); break;
        case 'min_dep_desc': list.sort((a, b) => (b.min_deposit || 0) - (a.min_deposit || 0)); break;
      }
      return list;
    },

    b1DepBarData() {
      const list = [...this.b1Brokers].sort((a, b) => (b.orders_amount || 0) - (a.orders_amount || 0)).slice(0, 10);
      const max = Math.max(...list.map(b => b.orders_amount || 0), 1);
      return list.map(b => ({
        name: b.name,
        shortName: this.b1ShortName(b.name),
        val: b.orders_amount || 0,
        pct: Math.round(((b.orders_amount || 0) / max) * 100)
      }));
    },

    b1CpaBarData() {
      const list = [...this.b1Brokers].filter(b => b.avg_cpa > 0).sort((a, b) => (b.avg_cpa || 0) - (a.avg_cpa || 0)).slice(0, 10);
      const max = Math.max(...list.map(b => b.avg_cpa || 0), 1);
      return list.map(b => ({
        name: b.name,
        shortName: this.b1ShortName(b.name),
        val: b.avg_cpa || 0,
        pct: Math.round(((b.avg_cpa || 0) / max) * 100)
      }));
    },

    b1GlobalPipeline() {
      const out = {};
      this.b1PipelineStages.forEach(s => { out[s.key] = 0; });
      this.b1Brokers.forEach(b => {
        if (!b.pipeline) return;
        this.b1PipelineStages.forEach(s => {
          out[s.key] = (out[s.key] || 0) + (b.pipeline[s.key] || 0);
        });
      });
      return out;
    },

    b1CalGrid() {
      const { year, month } = this.b1Cal;
      const firstOfMonth = new Date(year, month, 1);
      const startDow = (firstOfMonth.getDay() + 6) % 7;
      const today = new Date();
      const todayStr = this.b1FmtDateKey(today);
      const weeks = [];
      const cursor = new Date(year, month, 1 - startDow);
      for (let w = 0; w < 6; w++) {
        const week = [];
        for (let d = 0; d < 7; d++) {
          const dateStr = this.b1FmtDateKey(cursor);
          const inMonth = cursor.getMonth() === month;
          const dayDeps = this.b1CalDeposits[dateStr] || [];
          const count = dayDeps.length;
          // unique brokers for color dots
          const brokerMap = {};
          dayDeps.forEach(dep => {
            if (dep.broker_id && !brokerMap[dep.broker_id]) {
              const broker = this.b1Brokers.find(b => b.id === dep.broker_id);
              brokerMap[dep.broker_id] = {
                id: dep.broker_id,
                name: dep.broker_name || (broker && broker.name) || '',
                color: this.b1BrokerColorById(dep.broker_id)
              };
            }
          });
          week.push({
            date: dateStr,
            day: cursor.getDate(),
            inMonth,
            today: dateStr === todayStr,
            count,
            brokerDots: Object.values(brokerMap)
          });
          cursor.setDate(cursor.getDate() + 1);
        }
        weeks.push(week);
        if (w >= 3 && cursor.getMonth() !== month) break;
      }
      return weeks;
    },

    b1CalDayDeposits() {
      if (!this.b1CalSelected) return [];
      return this.b1CalDeposits[this.b1CalSelected] || [];
    },

    b1CalDayByBroker() {
      const deps = this.b1CalDayDeposits;
      if (!deps.length) return [];
      const map = {};
      deps.forEach(dep => {
        const bid = dep.broker_id || 0;
        if (!map[bid]) {
          map[bid] = {
            brokerId: bid,
            brokerName: dep.broker_name || ('Broker #' + bid),
            color: this.b1BrokerColorById(bid),
            deposits: []
          };
        }
        map[bid].deposits.push(dep);
      });
      return Object.values(map).sort((a, b) => b.deposits.length - a.deposits.length);
    },

    b1DetailConvRate() {
      if (!this.b1DetailBroker || !this.b1DetailBroker.pipeline) return 0;
      const p = this.b1DetailBroker.pipeline;
      const total = this.b1PipelineStages.reduce((s, st) => s + (p[st.key] || 0), 0);
      if (!total) return 0;
      const done = (p['DONE_SALES'] || 0) + (p['DONE_SUPPORT'] || 0) + (p['APPROVED'] || 0);
      return Math.round((done / total) * 100);
    },
    c1CurrentPageLabel() {
      const map = {
        '/clients1':'Clients', '/tasks1':'Tasks', '/stats1':'Statistics',
        '/chat1':'Chat', '/communications1':'Communications', '/affiliation1':'Affiliation',
        '/finance1':'Finance', '/shifts1':'Shifts', '/games1':'Games',
        '/users1':'Users', '/brokers1':'Brokers', '/security1':'Security',
        '/quiz1':'Quiz', '/instruction1':'Instructions', '/settings1':'Settings', '/profile1':'My Profile',
      };
      return map[this.$route.path] || 'Menu';
    },
    c1UserInitials() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "?";
      return ((u.first_name || "")[0] || "").toUpperCase() + ((u.last_name || "")[0] || "").toUpperCase();
    },
    c1UserFullName() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "User";
      return ((u.first_name || "") + " " + (u.last_name || "")).trim() || "User";
    },
    c1RoleLabel() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      const map = { 1:"Admin",2:"Team Leader",3:"Manager",4:"Senior Agent",5:"Agent",6:"Junior Agent",10:"Finance",12:"Super Admin" };
      return map[u && u.role] || "User";
    },
    c1TzUK() { return this.c1TzTime("Europe/London"); },
    c1TzIL() { return this.c1TzTime("Asia/Jerusalem"); },
    c1TzCB() { return this.c1TzTime("America/Cayman"); },
  },

  created() {
    if (sessionStorage.getItem('c1keepNav')) { sessionStorage.removeItem('c1keepNav'); this.c1SlideOpen = 'nav'; this.c1NavMode = 'panels'; }
    sessionStorage.removeItem('c1openPanel');
    this.b1Load();
    this.b1StartClock();
    this.b1CheckSyncStatus();
    this.b1GenerateVikiNotifs();
    // Poll Viki every 60s
    this.b1VikiInterval = setInterval(() => this.b1PollViki(), 60000);
    // Poll sync status every 30s
    this.b1SyncInterval = setInterval(() => this.b1CheckSyncStatus(), 30000);
  },

  beforeDestroy() {
    if (this._c1StatusInterval) clearInterval(this._c1StatusInterval);
    if (this.b1TimeInterval) clearInterval(this.b1TimeInterval);
    if (this.b1VikiInterval) clearInterval(this.b1VikiInterval);
    if (this.b1SyncInterval) clearInterval(this.b1SyncInterval);
  },

  watch: {
    'c1SlideOpen': function(val) {
      if (val && val !== 'nav' && val !== 'menu') {
        this.c1PanelActiveContent = val;
        if (val === 'calendar') {
          this.b1LoadCalDeposits();
        }
      }
    }
  },

  mounted() {
    document.documentElement.style.setProperty('--gnm-sw', '0px');
    const savedStatus = localStorage.getItem('c1_status');
    const savedSince  = localStorage.getItem('c1_status_since');
    const today = new Date().toISOString().slice(0, 10);
    const savedShiftDay = localStorage.getItem('c1_shift_day');
    if (savedShiftDay !== today) {
      this.c1ShiftStartTime = Date.now();
      this.c1BathroomCount = 0;
      this.c1CoffeeCount = 0;
      localStorage.setItem('c1_status', 'shift');
      localStorage.setItem('c1_status_since', String(Date.now()));
      localStorage.setItem('c1_shift_start', String(Date.now()));
      localStorage.setItem('c1_shift_day', today);
      localStorage.setItem('c1_bathroom_count', '0');
      localStorage.setItem('c1_coffee_count', '0');
    } else {
      if (savedStatus) this.c1Status = savedStatus;
      this.c1ShiftStartTime = parseInt(localStorage.getItem('c1_shift_start') || String(Date.now()), 10);
      this.c1BathroomCount = parseInt(localStorage.getItem('c1_bathroom_count') || '0', 10);
      this.c1CoffeeCount   = parseInt(localStorage.getItem('c1_coffee_count') || '0', 10);
    }
    this.c1StatusSince = savedSince ? parseInt(savedSince, 10) : Date.now();
    this._c1StatusInterval = setInterval(this.c1TickStatus, 1000);
  },

  methods: {
    c1SetStatus(s) {
      if (s === 'bathroom') this.c1BathroomCount++;
      if (s === 'coffee')   this.c1CoffeeCount++;
      this.c1Status = s;
      this.c1StatusSince = Date.now();
      this.c1StatusElapsed = '00:00';
      this.c1ShiftMenuOpen = false;
      localStorage.setItem('c1_status', s);
      localStorage.setItem('c1_status_since', String(this.c1StatusSince));
      if (s === 'bathroom') localStorage.setItem('c1_bathroom_count', String(this.c1BathroomCount));
      if (s === 'coffee')   localStorage.setItem('c1_coffee_count',   String(this.c1CoffeeCount));
      if (s === 'end') this.c1SaveTodayToLog();
    },
    c1TickStatus() {
      const fmtSec = (sec) => {
        const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s2 = sec % 60;
        return h > 0
          ? String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0')
          : String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0');
      };
      this.c1StatusElapsed = fmtSec(Math.floor((Date.now() - this.c1StatusSince) / 1000));
      this.c1ShiftElapsed  = fmtSec(Math.floor((Date.now() - this.c1ShiftStartTime) / 1000));
    },
    c1SaveTodayToLog() {
      try {
        const today = new Date().toISOString().slice(0, 10);
        const workedMin = Math.floor((Date.now() - this.c1ShiftStartTime) / 60000);
        const log = JSON.parse(localStorage.getItem('c1_week_log') || '[]').filter(r => r.date !== today);
        log.unshift({ date: today, workedMin: Math.max(0, workedMin), bathroom: this.c1BathroomCount, coffee: this.c1CoffeeCount });
        localStorage.setItem('c1_week_log', JSON.stringify(log.slice(0, 14)));
        this.c1WeekLog = log.slice(0, 14);
      } catch(e) {}
    },
    c1TzTime(tz) {
      try {
        return new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz });
      } catch(e) { return "--:--"; }
    },
    c1Logout() {
      this.$store.dispatch('user/logOut');
    },
    c1PanelBtnClick() {
      this.c1SlideOpen = this.c1PanelIsOpen ? null : 'nav';
    },
    c1SelectPanel(panel) {
      this.c1SlideOpen = panel;
    },
    c1FilterPanelClick(e) {
      // Panel stays open after selecting a filter option — user uses back (←) or X to navigate/close
    },

    // ── Auth ──────────────────────────────────────────────────────────
    b1Token() {
      try { return (this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.token) || localStorage.getItem('user-token') || ''; }
      catch (e) { return localStorage.getItem('user-token') || ''; }
    },

    b1Headers() {
      return { Authorization: 'Bearer ' + this.b1Token() };
    },

    // ── Load brokers ──────────────────────────────────────────────────
    async b1Load() {
      this.b1Loading = true;
      try {
        const res = await fetch(API + '/brokers/table', { headers: this.b1Headers() });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const json = await res.json();
        this.b1Brokers = (json.data || json || []);
        this.b1CheckForInactiveBrokers();
      } catch (e) {
        console.error('[Brokers1] load error', e);
        this.b1Brokers = [];
        this.b1ShowToast('Failed to load brokers', '#ef4444');
      } finally {
        this.b1Loading = false;
      }
    },

    // ── Detail drawer ─────────────────────────────────────────────────
    async b1OpenDetail(broker) {
      this.b1DetailBroker = broker;
      this.b1DetailTab = 'profile';
      this.b1DetailOpen = true;
      this.b1DetailDeposits = [];
      this.b1DetailMonthly = [];
      this.b1DetailClients = [];
      this.b1DetailAgents = [];
      this.b1DepRange = '30d';
      await Promise.all([
        this.b1LoadDetailDeposits(broker),
        this.b1LoadDetailClients(broker),
        this.b1LoadDetailAgents(broker)
      ]);
    },

    async b1LoadDetailDeposits(broker) {
      if (!broker) return;
      this.b1DetailLoadingDeps = true;
      try {
        // Deposit stats endpoint not yet implemented — load broker detail from table with broker_id filter
        const res = await fetch(API + `/brokers/table?broker_id=${broker.id}`, { headers: this.b1Headers() });
        const json = await res.json();
        const deps = json.data || json || [];
        this.b1DetailDeposits = Array.isArray(deps) ? deps.slice(0, 50) : [];
        this.b1DetailMonthly = this.b1BuildMonthlyChart(this.b1DetailDeposits);
      } catch (e) {
        console.error('[Brokers1] deposits load error', e);
        this.b1DetailDeposits = [];
      } finally {
        this.b1DetailLoadingDeps = false;
      }
    },

    async b1LoadDetailClients(broker) {
      if (!broker) return;
      this.b1DetailLoadingClients = true;
      try {
        // Per-broker clients endpoint not implemented — fetch affiliation table filtered by broker
        const res = await fetch(API + `/affiliation/table?broker_id=${broker.id}`, { headers: this.b1Headers() });
        const json = await res.json();
        this.b1DetailClients = json.data || json || [];
      } catch (e) {
        this.b1DetailClients = [];
      } finally {
        this.b1DetailLoadingClients = false;
      }
    },

    async b1LoadDetailAgents(broker) {
      if (!broker) return;
      this.b1DetailLoadingAgents = true;
      try {
        // Per-broker agents endpoint not implemented — fetch from admin users filtered by team/broker
        const res = await fetch(API + `/users/get_users_names`, { headers: this.b1Headers() });
        const json = await res.json();
        this.b1DetailAgents = json.data || json || [];
      } catch (e) {
        // Fallback: empty list until dedicated endpoint is available
        this.b1DetailAgents = [];
      } finally {
        this.b1DetailLoadingAgents = false;
      }
    },

    b1DepRangeToParams(range) {
      const to = new Date();
      const from = new Date();
      if (range === '7d')  { from.setDate(from.getDate() - 7); }
      else if (range === '30d') { from.setDate(from.getDate() - 30); }
      else if (range === '90d') { from.setDate(from.getDate() - 90); }
      else { from.setFullYear(from.getFullYear() - 10); } // all
      return {
        from: this.b1FmtDateKey(from),
        to: this.b1FmtDateKey(to)
      };
    },

    b1BuildMonthlyChart(deposits) {
      if (!deposits || deposits.length === 0) return [];
      const counts = {};
      deposits.forEach(dep => {
        if (!dep.created_at) return;
        const d = new Date(dep.created_at);
        const key = this.b1CalMonthNames[d.getMonth()].slice(0, 3) + ' ' + String(d.getFullYear()).slice(2);
        counts[key] = (counts[key] || 0) + 1;
      });
      const keys = Object.keys(counts).slice(-6);
      const max = Math.max(...keys.map(k => counts[k]), 1);
      return keys.map(k => ({ label: k, val: counts[k], pct: Math.round((counts[k] / max) * 100) }));
    },

    // ── Pipeline helpers ──────────────────────────────────────────────
    b1DistPct(stageKey) {
      if (!this.b1DetailBroker || !this.b1DetailBroker.pipeline) return 0;
      const p = this.b1DetailBroker.pipeline;
      const total = this.b1PipelineStages.reduce((s, st) => s + (p[st.key] || 0), 0);
      if (!total) return 0;
      return Math.round(((p[stageKey] || 0) / total) * 100);
    },

    b1SsKey(subStatus) {
      if (!subStatus) return 'default';
      return subStatus.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
    },

    // ── Add / Edit broker ─────────────────────────────────────────────
    b1OpenAddDrawer() {
      this.b1EditMode = false;
      this.b1EditBrokerId = null;
      this.b1AddOpen = true;
      this.b1AddError = null;
      this.b1AddSuccess = null;
      this.b1AddForm = { name: '', min_deposit: null, avg_cpa: null, contact_name: '', contact_skype: '', deposit_methods: '', regulated: false, count_twice: false, active: true };
    },

    b1OpenEditDrawer(broker) {
      this.b1EditMode = true;
      this.b1EditBrokerId = broker.id;
      this.b1AddOpen = true;
      this.b1AddError = null;
      this.b1AddSuccess = null;
      this.b1AddForm = {
        name: broker.name || '',
        min_deposit: broker.min_deposit || null,
        avg_cpa: broker.avg_cpa || null,
        contact_name: broker.contact_name || '',
        contact_skype: broker.contact_skype || '',
        deposit_methods: broker.deposit_methods || broker.payment_methods || '',
        regulated: !!broker.regulated,
        count_twice: !!broker.count_twice,
        active: !!broker.active
      };
    },

    async b1SubmitAdd() {
      if (!this.b1AddForm.name) return;
      this.b1AddLoading = true;
      this.b1AddError = null;
      this.b1AddSuccess = null;
      try {
        const method = this.b1EditMode ? 'PUT' : 'POST';
        const endpoint = this.b1EditMode
          ? API + `/admin/broker/${this.b1EditBrokerId}`
          : API + '/admin/broker';
        const res = await fetch(endpoint, {
          method,
          headers: { ...this.b1Headers(), 'Content-Type': 'application/json' },
          body: JSON.stringify(this.b1AddForm)
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.message || 'Failed to save broker');
        }
        this.b1AddSuccess = this.b1EditMode ? 'Broker updated successfully!' : 'Broker created successfully!';
        await this.b1Load();
        setTimeout(() => { this.b1AddOpen = false; }, 1200);
        this.b1ShowToast(this.b1AddSuccess, '#22c55e');
      } catch (e) {
        this.b1AddError = e.message || 'Something went wrong. Try again.';
      } finally {
        this.b1AddLoading = false;
      }
    },

    async b1ToggleBrokerActive(broker) {
      try {
        const res = await fetch(API + `/admin/broker/${broker.id}`, {
          method: 'PUT',
          headers: { ...this.b1Headers(), 'Content-Type': 'application/json' },
          body: JSON.stringify({ active: !broker.active })
        });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        broker.active = !broker.active;
        this.b1ShowToast(`${broker.name} set to ${broker.active ? 'active' : 'inactive'}`, '#6366f1');
        // Add Viki alert
        this.b1VikiPush({
          type: 'alert',
          msg: `${broker.name} is now ${broker.active ? 'ACTIVE' : 'INACTIVE'}`,
          time: this.b1FmtNow()
        });
      } catch (e) {
        this.b1ShowToast('Failed to update broker status', '#ef4444');
      }
    },

    // ── Calendar ──────────────────────────────────────────────────────
    async b1CalBrokerChanged() {
      await this.b1LoadCalDeposits();
    },

    async b1LoadCalDeposits() {
      const { year, month } = this.b1Cal;
      const from = `${year}-${String(month + 1).padStart(2, '0')}-01`;
      const lastDay = new Date(year, month + 1, 0).getDate();
      const to = `${year}-${String(month + 1).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
      try {
        // brokers/stats/deposits not implemented — use brokers/table with date params
        const brokerParam = this.b1CalBroker ? `&broker_id=${this.b1CalBroker}` : '';
        const res = await fetch(
          API + `/brokers/table?date_from=${from}&date_to=${to}${brokerParam}`,
          { headers: this.b1Headers() }
        );
        const json = await res.json();
        const deposits = json.data || json || [];
        const map = {};
        deposits.forEach(dep => {
          if (!dep.created_at) return;
          const key = dep.created_at.slice(0, 10);
          if (!map[key]) map[key] = [];
          map[key].push(dep);
        });
        this.b1CalDeposits = map;
      } catch (e) {
        console.error('[Brokers1] calendar load error', e);
        this.b1CalDeposits = {};
      }
    },

    b1CalSelectDay(dateStr) {
      this.b1CalSelected = this.b1CalSelected === dateStr ? null : dateStr;
    },

    b1CalPrev() {
      if (this.b1Cal.month === 0) { this.b1Cal.month = 11; this.b1Cal.year--; }
      else this.b1Cal.month--;
      this.b1LoadCalDeposits();
    },

    b1CalNext() {
      if (this.b1Cal.month === 11) { this.b1Cal.month = 0; this.b1Cal.year++; }
      else this.b1Cal.month++;
      this.b1LoadCalDeposits();
    },

    // ── Viki ──────────────────────────────────────────────────────────
    b1GenerateVikiNotifs() {
      // Seed initial Viki notifications from broker state
      const notifs = [];
      this.b1Brokers.forEach(b => {
        if (!b.active) {
          notifs.push({
            id: 'inactive-' + b.id,
            type: 'alert',
            msg: `Broker ${b.name} is currently INACTIVE`,
            time: this.b1FmtNow(),
            read: false
          });
        }
      });
      this.b1VikiNotifs = notifs.slice(0, 20);
      this.b1VikiUnread = notifs.filter(n => !n.read).length;
    },

    async b1PollViki() {
      // Poll for new deposit events from broker stats
      if (!this.b1Brokers.length) return;
      const now = new Date();
      const from = this.b1FmtDateKey(new Date(now.getTime() - 60 * 1000));
      const to = this.b1FmtDateKey(now);
      try {
        // brokers/stats/deposits not implemented — skip polling, use brokers/table for live data
        const res = await fetch(API + `/brokers/table?date_from=${from}&date_to=${to}`, { headers: this.b1Headers() });
        const json = await res.json();
        const deps = json.data || json || [];
        deps.slice(0, 5).forEach(dep => {
          const broker = this.b1Brokers.find(b => b.id === dep.broker_id);
          this.b1VikiPush({
            type: 'deposit',
            msg: `New deposit via ${broker ? broker.name : ('Broker #' + dep.broker_id)}: ${dep.country || '?'} $${dep.amount || '?'}`,
            time: this.b1FmtNow()
          });
        });
      } catch (e) { /* silent */ }
    },

    b1VikiPush(notif) {
      const item = { id: Date.now() + Math.random(), read: false, ...notif };
      this.b1VikiNotifs.unshift(item);
      if (this.b1VikiNotifs.length > 50) this.b1VikiNotifs.pop();
      this.b1VikiUnread = this.b1VikiNotifs.filter(n => !n.read).length;
    },

    b1VikiRead(notif) {
      notif.read = true;
      this.b1VikiUnread = this.b1VikiNotifs.filter(n => !n.read).length;
    },

    b1MarkAllVikiRead() {
      this.b1VikiNotifs.forEach(n => { n.read = true; });
      this.b1VikiUnread = 0;
    },

    b1CheckForInactiveBrokers() {
      this.b1Brokers.forEach(b => {
        if (!b.active) {
          const exists = this.b1VikiNotifs.find(n => n.id === 'inactive-' + b.id);
          if (!exists) {
            this.b1VikiPush({
              id: 'inactive-' + b.id,
              type: 'alert',
              msg: `Broker ${b.name} is currently INACTIVE`,
              time: this.b1FmtNow()
            });
          }
        }
      });
    },

    // ── Sync status ───────────────────────────────────────────────────
    async b1CheckSyncStatus() {
      try {
        // brokers/sync/status not implemented — derive from brokers/table response timestamp
        const res = await fetch(API + '/brokers/table', { headers: this.b1Headers() });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const json = await res.json();
        // Use X-Date header or current time as last sync indicator
        this.b1LastSyncAt = res.headers.get('Date') || new Date().toISOString();
        this.b1SyncActive = false;
        this.b1UpdateSyncLabel();
      } catch (e) {
        // Fallback: calculate from local time
        if (!this.b1LastSyncAt) {
          const mins = Math.floor(Math.random() * 5);
          this.b1LastSyncLabel = `Synced ${mins}m ago`;
        }
      }
    },

    b1UpdateSyncLabel() {
      if (!this.b1LastSyncAt) { this.b1LastSyncLabel = 'Never synced'; return; }
      const diff = Math.floor((Date.now() - new Date(this.b1LastSyncAt).getTime()) / 1000);
      if (diff < 60) { this.b1LastSyncLabel = `Synced ${diff}s ago`; }
      else if (diff < 3600) { this.b1LastSyncLabel = `Synced ${Math.floor(diff / 60)}m ago`; }
      else { this.b1LastSyncLabel = `Synced ${Math.floor(diff / 3600)}h ago`; }
    },

    async b1ManualSync() {
      this.b1SyncActive = true;
      this.b1LastSyncLabel = 'Syncing…';
      try {
        // brokers/sync not implemented — trigger a reload of brokers/table as a soft sync
        await this.b1Load();
        this.b1LastSyncAt = new Date().toISOString();
        this.b1UpdateSyncLabel();
        this.b1ShowToast('Broker sync complete', '#22c55e');
      } catch (e) {
        this.b1ShowToast('Sync failed', '#ef4444');
      } finally {
        this.b1SyncActive = false;
      }
    },

    // ── Schedule call ─────────────────────────────────────────────────
    b1ScheduleCall(broker) {
      this.b1ShowToast(`Scheduled call to ${broker.name}`, '#6366f1');
      this.b1VikiPush({
        type: 'info',
        msg: `Call scheduled with ${broker.name} (${broker.contact_name || 'contact'})`,
        time: this.b1FmtNow()
      });
    },

    // ── UI helpers ────────────────────────────────────────────────────
    b1OpenSlide(name) {
      this.b1SlideOpen = this.b1SlideOpen === name ? null : name;
      if (name === 'calendar' && this.b1SlideOpen === 'calendar') {
        this.b1LoadCalDeposits();
      }
    },

    b1ToggleExpand(id) {
      this.b1Expanded = this.b1Expanded === id ? null : id;
    },

    b1ResetFilters() {
      this.b1Filters = { active: null, regulated: null, count_twice: null, minDepositMin: null, minDepositMax: null, search: '' };
      this.b1Load();
    },

    b1ShowToast(msg, color) {
      if (this.b1ToastTimer) clearTimeout(this.b1ToastTimer);
      this.b1Toast = { msg, color: color || '#6366f1' };
      this.b1ToastTimer = setTimeout(() => { this.b1Toast = null; }, 3000);
    },

    b1StartClock() {
      const tick = () => {
        const d = new Date();
        this.b1TimeStr = String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
        this.b1UpdateSyncLabel();
      };
      tick();
      this.b1TimeInterval = setInterval(tick, 10000);
    },

    // ── Formatting ────────────────────────────────────────────────────
    b1Initials(name) {
      if (!name) return '?';
      const parts = name.trim().split(/\s+/);
      return ((parts[0] ? parts[0][0] : '') + (parts[1] ? parts[1][0] : '')).toUpperCase() || name[0].toUpperCase();
    },

    b1ShortName(name) {
      if (!name) return '?';
      return name.length > 10 ? name.slice(0, 9) + '…' : name;
    },

    b1ClientInitials(client) {
      return ((client.first_name ? client.first_name[0] : '') + (client.last_name ? client.last_name[0] : '')).toUpperCase() || '?';
    },

    b1AgentInitials(agent) {
      return ((agent.first_name ? agent.first_name[0] : '') + (agent.last_name ? agent.last_name[0] : '')).toUpperCase() || '?';
    },

    b1FmtDate(ts) {
      if (!ts) return '—';
      try { return new Date(ts).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }); }
      catch (e) { return ts; }
    },

    b1FmtDateKey(date) {
      const d = date instanceof Date ? date : new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    },

    b1FmtNow() {
      const d = new Date();
      return d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
    },

    b1BrokerColor(broker) {
      if (!broker) return this.b1Colors[0];
      return this.b1Colors[broker.id % this.b1Colors.length];
    },

    b1BrokerColorById(id) {
      return this.b1Colors[(id || 0) % this.b1Colors.length];
    },

    b1AgentColor(id) {
      return this.b1AgentColors[(id || 0) % this.b1AgentColors.length];
    },

    b1AgentBarPct(agent) {
      const max = Math.max(...this.b1DetailAgents.map(a => a.deposit_count || 0), 1);
      return Math.round(((agent.deposit_count || 0) / max) * 100);
    },

    b1RoleFromId(roleId) {
      const map = { 1:'Admin', 2:'Team Leader', 3:'Manager', 4:'Senior Agent', 5:'Agent', 6:'Junior Agent', 7:'New Agent', 8:'Support', 9:'Retention', 10:'Finance', 12:'Super Admin' };
      return map[roleId] || 'Agent';
    },

  }
};
</script>

<style scoped>
/* =============================================
   BROKERS1 — complete scoped styles
   ============================================= */

/* Hide the right-side panel — replaced by top strip */
.c1-brokers-page .c1-panel { display: none !important; }


.c1-main {
  --c1-bg:       #f4f3f0;
  --c1-surface:  #ffffff;
  --c1-surface2: #f4f3f0;
  --c1-border:   #e4e3df;
  --c1-text:     #1a1a1a;
  --c1-muted:    #64748b;
  --c1-accent:   #6366f1;
  --c1-accent2:  #8b5cf6;
  --c1-dp:       #22c55e;
  --c1-ld:       #f59e0b;
  --c1-na:       #ef4444;
  --c1-sc:       #3b82f6;
  --c1-rf:       #a855f7;

  --b1-bg:       var(--c1-bg);
  --b1-surface:  var(--c1-surface);
  --b1-brd:      var(--c1-border);
  --b1-brd-l:    #eeedea;
  --b1-t1:       var(--c1-text);
  --b1-t2:       #6b6963;
  --b1-t3:       #a09e98;
  --b1-ac:       var(--c1-accent);
  --b1-ac-soft:  rgba(124,92,252,.12);
  --b1-green:    var(--c1-dp);
  --b1-amber:    var(--c1-ld);
  --b1-red:      var(--c1-na);
  --b1-act:      rgba(0,0,0,.05);

  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

/* ── Top bar overrides ── */
.c1-main .c1-tib {
  background: var(--c1-card, #fff) !important;
  border-bottom-color: var(--c1-brd, #e4e3df) !important;
}
.c1-main .c1-tib-btn { color: var(--b1-t2) !important; }
.c1-main .c1-tib-btn:hover { background: var(--b1-act) !important; color: var(--b1-t1) !important; }
.c1-main .c1-tib-btn.on { background: var(--b1-ac-soft) !important; color: var(--b1-ac) !important; }
.c1-main .c1-tib-btn.on svg { stroke: var(--b1-ac) !important; }
.c1-main .c1-tib-user { background: var(--b1-ac) !important; cursor: pointer; }
.c1-main .c1-tib-udot { border-color: var(--b1-surface) !important; }
.c1-main .c1-tib-udot.online { background: var(--b1-green) !important; }
.c1-tib-badge {
  background: var(--b1-ac);
  color: #fff;
  font-size: 8px;
  font-weight: 800;
  padding: 1px 5px;
  border-radius: 8px;
  margin-left: 2px;
}

/* ── Viki button ── */
.b1-viki-btn { position: relative; }
.b1-viki-notif {
  position: absolute;
  top: 4px; right: 2px;
  background: var(--b1-red);
  color: #fff;
  font-size: 7px;
  font-weight: 800;
  padding: 1px 4px;
  border-radius: 8px;
  min-width: 14px;
  text-align: center;
  line-height: 1.4;
}

/* ── Panels (inline slide-down) ── */
.b1-panel {
  background: var(--b1-surface);
  border-bottom: 1px solid var(--b1-brd);
  overflow-y: auto;
  max-height: 70vh;
}
.b1-panel-hdr {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid var(--b1-brd);
  font-size: 12px;
  font-weight: 700;
  color: var(--b1-t1);
  flex-shrink: 0;
}
.b1-panel-hdr svg { width: 14px; height: 14px; stroke: var(--b1-ac); fill: none; stroke-width: 2; flex-shrink: 0; }
.b1-panel-hdr-count { font-size: 10px; color: var(--b1-ac); background: var(--b1-ac-soft); padding: 1px 7px; border-radius: 8px; }
.b1-panel-reset { font-size: 10px; color: var(--b1-t3); cursor: pointer; padding: 3px 8px; border-radius: 6px; }
.b1-panel-reset:hover { color: var(--b1-red); background: rgba(239,68,68,.08); }
.b1-panel-close {
  width: 24px; height: 24px;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; border-radius: 6px; color: var(--b1-t3);
}
.b1-panel-close:hover { background: var(--b1-act); color: var(--b1-t1); }
.b1-panel-close svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; }

.c1-main .c1-sl-body {
  padding: 14px 16px 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.c1-main .c1-fp-group { min-width: 0; flex: 1 1 140px; }
.c1-main .c1-fp-full { flex: 1 1 100%; }
.c1-main .c1-fp-lbl {
  font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px;
  color: var(--b1-t3); margin-bottom: 6px;
}
.c1-main .c1-fp-opts { display: flex; flex-wrap: wrap; gap: 5px; }
.c1-main .c1-fp-opt {
  padding: 4px 10px; border-radius: 16px; border: 1px solid var(--b1-brd);
  font-size: 11px; font-weight: 500; color: var(--b1-t2); cursor: pointer;
  transition: all .12s; background: transparent; white-space: nowrap;
}
.c1-main .c1-fp-opt:hover { border-color: var(--b1-ac); color: var(--b1-t1); }
.c1-main .c1-fp-opt.on { background: var(--b1-ac-soft); border-color: var(--b1-ac); color: var(--b1-ac); }
.b1-chip-reg.on  { background: rgba(34,197,94,.15) !important; border-color: var(--b1-green) !important; color: var(--b1-green) !important; }
.b1-chip-unreg.on { background: rgba(239,68,68,.12) !important; border-color: var(--b1-red) !important; color: var(--b1-red) !important; }
.b1-chip-ct.on  { background: rgba(245,158,11,.15) !important; border-color: var(--b1-amber) !important; color: var(--b1-amber) !important; }

/* Range inputs */
.b1-range-row { display: flex; align-items: center; gap: 6px; }
.b1-range-input {
  flex: 1; padding: 5px 8px; background: var(--b1-bg); border: 1px solid var(--b1-brd);
  border-radius: 6px; color: var(--b1-t1); font-size: 12px; outline: none; min-width: 0;
}
.b1-range-input:focus { border-color: var(--b1-ac); }
.b1-range-sep { color: var(--b1-t3); font-size: 11px; flex-shrink: 0; }

/* Search */
.c1-main .c1-fp-search {
  display: flex; align-items: center; gap: 6px;
  background: var(--b1-bg); border: 1px solid var(--b1-brd); border-radius: 8px; padding: 0 8px;
}
.c1-main .c1-fp-sico { width: 14px; height: 14px; stroke: var(--b1-t3); fill: none; stroke-width: 2; flex-shrink: 0; }
.c1-main .c1-fp-sinput {
  flex: 1; padding: 7px 0; background: transparent; border: none;
  color: var(--b1-t1); font-size: 12px; outline: none;
}
.c1-main .c1-fp-sinput::placeholder { color: var(--b1-t3); }
.c1-main .c1-fp-sclear { cursor: pointer; color: var(--b1-t3); display: flex; align-items: center; }
.c1-main .c1-fp-sclear svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; }

/* Collapse bar */
.c1-main .c1-collapse-bar {
  display: flex; align-items: center; justify-content: center; gap: 5px;
  padding: 8px; cursor: pointer;
  background: var(--b1-surface) !important; border-top: 1px solid var(--b1-brd) !important;
  color: var(--b1-t3) !important; font-size: 11px;
}
.c1-main .c1-collapse-bar svg { stroke: currentColor; width: 14px; height: 14px; fill: none; stroke-width: 2; }

/* ── KPI row ── */
.c1-main .c1-co-lbl {
  font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px;
  color: var(--b1-t3); margin-bottom: 8px;
}
.c1-main .c1-kpi-row { display: flex; gap: 8px; flex-wrap: wrap; }
.c1-main .c1-kpi {
  flex: 1 1 70px; background: var(--b1-bg); border: 1px solid var(--b1-brd);
  border-radius: 10px; padding: 10px 12px; min-width: 60px;
}
.c1-main .c1-kpi-lbl { font-size: 9px; color: var(--b1-t3); font-weight: 600; text-transform: uppercase; letter-spacing: .4px; margin-bottom: 4px; }
.c1-main .c1-kpi-val { font-size: 20px; font-weight: 700; color: var(--b1-t1); line-height: 1; }

/* ── Bar charts ── */
.c1-main .c1-vbar-chart { display: flex; flex-direction: column; gap: 6px; }
.c1-main .c1-vbar-row { display: flex; align-items: center; gap: 8px; }
.b1-vbar-lbl-broker { width: 72px; font-size: 10px; font-weight: 500; color: var(--b1-t2); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex-shrink: 0; }
.c1-main .c1-vbar-track { flex: 1; height: 16px; background: var(--b1-bg); border-radius: 4px; overflow: hidden; }
.b1-bar-fill {
  height: 100%; background: linear-gradient(90deg, var(--b1-ac), #818cf8);
  border-radius: 4px; display: flex; align-items: center; justify-content: flex-end;
  padding-right: 5px; min-width: 18px; transition: width .35s ease;
}
.b1-bar-fill-cpa {
  height: 100%; background: linear-gradient(90deg, var(--b1-amber), #fbbf24);
  border-radius: 4px; display: flex; align-items: center; justify-content: flex-end;
  padding-right: 5px; min-width: 22px; transition: width .35s ease;
}
.c1-main .c1-vbar-val { font-size: 9px; font-weight: 700; color: #fff; }
.b1-chart-empty { font-size: 11px; color: var(--b1-t3); padding: 8px 0; }

/* ── Pipeline summary (charts panel) ── */
.b1-pipeline-summary {
  display: flex; flex-wrap: wrap; gap: 6px;
}
.b1-ps-item {
  display: flex; flex-direction: column; align-items: center;
  background: var(--b1-bg); border: 1px solid var(--b1-brd);
  border-radius: 8px; padding: 7px 10px; min-width: 44px;
  border-top: 2px solid var(--ps-clr);
}
.b1-ps-num { font-size: 16px; font-weight: 800; color: var(--ps-clr); line-height: 1; }
.b1-ps-lbl { font-size: 8px; color: var(--b1-t3); text-transform: uppercase; letter-spacing: .3px; margin-top: 3px; }

/* ── Count twice ── */
.b1-ct-impact-wrap { display: flex; gap: 10px; flex-wrap: wrap; }
.b1-ct-item { flex: 1 1 60px; background: var(--b1-bg); border: 1px solid var(--b1-brd); border-radius: 10px; padding: 10px 12px; text-align: center; }
.b1-ct-num { font-size: 22px; font-weight: 800; color: var(--b1-t1); line-height: 1; }
.b1-ct-num-orange { color: var(--b1-amber); }
.b1-ct-num-green { color: var(--b1-green); }
.b1-ct-lbl { font-size: 9px; color: var(--b1-t3); margin-top: 4px; text-transform: uppercase; letter-spacing: .3px; }

/* ── CALENDAR PANEL ── */
.b1-cal-panel { padding: 0; }
.b1-cal-hdr {
  display: flex; align-items: center; gap: 8px; padding: 10px 16px;
  border-bottom: 1px solid var(--b1-brd); font-size: 13px; font-weight: 600; color: var(--b1-t1);
}
.b1-cal-hdr svg { width: 16px; height: 16px; stroke: var(--b1-ac); fill: none; stroke-width: 2; flex-shrink: 0; }
.b1-cal-close {
  display: flex; align-items: center; gap: 4px; padding: 4px 10px; border-radius: 6px;
  background: var(--b1-act); border: none; color: var(--b1-t2); font-size: 11px; font-weight: 600; cursor: pointer;
}
.b1-cal-close svg { width: 12px; height: 12px; stroke: currentColor; fill: none; stroke-width: 2; }
.b1-cal-broker-row { display: flex; align-items: center; gap: 10px; padding: 10px 16px; border-bottom: 1px solid var(--b1-brd); }
.b1-cal-broker-lbl { font-size: 11px; font-weight: 600; color: var(--b1-t2); white-space: nowrap; }
.b1-cal-broker-sel { flex: 1; background: var(--b1-bg); border: 1px solid var(--b1-brd); color: var(--b1-t1); border-radius: 6px; padding: 5px 8px; font-size: 12px; outline: none; }
.b1-cal-nav { display: flex; align-items: center; justify-content: space-between; padding: 10px 16px; }
.b1-cal-nav-btn { background: var(--b1-act); border: none; color: var(--b1-t1); border-radius: 6px; padding: 6px 10px; cursor: pointer; display: flex; align-items: center; }
.b1-cal-nav-btn svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; }
.b1-cal-month-lbl { font-size: 13px; font-weight: 700; color: var(--b1-t1); }
.b1-cal-grid-wrap { padding: 0 16px 8px; }
.b1-cal-grid { display: grid; grid-template-columns: repeat(7, 1fr); gap: 2px; }
.b1-cal-dh { text-align: center; font-size: 9px; font-weight: 700; color: var(--b1-t3); text-transform: uppercase; letter-spacing: .4px; padding: 4px 0; }
.b1-cal-cell {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  padding: 4px 2px; border-radius: 6px; cursor: pointer; min-height: 38px;
  transition: background .12s; gap: 2px; position: relative;
}
.b1-cal-cell:hover { background: var(--b1-act); }
.b1-cal-other .b1-cal-day-num { color: var(--b1-t3); }
.b1-cal-day-num { font-size: 11px; font-weight: 500; color: var(--b1-t1); }
.b1-cal-today { border: 1px solid var(--b1-ac); }
.b1-cal-today .b1-cal-day-num { color: var(--b1-ac); font-weight: 700; }
.b1-cal-sel { background: var(--b1-ac-soft) !important; }
.b1-cal-sel .b1-cal-day-num { color: var(--b1-ac); font-weight: 700; }
.b1-cal-dot {
  width: 16px; height: 16px; border-radius: 50%; background: var(--b1-ac); color: #fff;
  font-size: 8px; font-weight: 700; display: flex; align-items: center; justify-content: center;
}
/* broker color dots */
.b1-cal-bdots { display: flex; gap: 2px; flex-wrap: wrap; justify-content: center; }
.b1-cal-bdot { width: 5px; height: 5px; border-radius: 50%; }
/* Day list */
.b1-cal-day-list { padding: 0 16px 16px; border-top: 1px solid var(--b1-brd); margin-top: 4px; }
.b1-cal-day-hdr { font-size: 11px; font-weight: 700; color: var(--b1-t1); padding: 10px 0 8px; display: flex; align-items: center; gap: 6px; }
.b1-cal-day-count { background: var(--b1-ac-soft); color: var(--b1-ac); border-radius: 10px; padding: 1px 7px; font-size: 10px; font-weight: 700; }
.b1-cal-broker-grp { margin-bottom: 10px; }
.b1-cal-grp-hdr { display: flex; align-items: center; gap: 6px; padding: 4px 0; }
.b1-cal-grp-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.b1-cal-grp-name { font-size: 11px; font-weight: 700; color: var(--b1-t1); }
.b1-cal-grp-cnt { background: var(--b1-act); color: var(--b1-t2); font-size: 9px; font-weight: 700; padding: 1px 6px; border-radius: 8px; }
.b1-cal-day-empty { font-size: 11px; color: var(--b1-t3); padding: 6px 0; }
.b1-cal-dep-row { display: flex; align-items: center; gap: 6px; padding: 4px 0 4px 14px; border-bottom: 1px solid var(--b1-brd-l); }
.b1-cal-dep-body { flex: 1; display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.b1-cal-dep-client { font-size: 11px; font-weight: 500; color: var(--b1-t1); }
.b1-cal-dep-country { font-size: 10px; color: var(--b1-t3); }
.b1-cal-dep-amt { font-size: 11px; font-weight: 700; color: var(--b1-green); margin-left: auto; }
.b1-cal-dep-status { font-size: 9px; font-weight: 700; padding: 2px 6px; border-radius: 6px; background: var(--b1-act); color: var(--b1-t3); white-space: nowrap; }

/* ── Sub-status chip colors ── */
.b1-ss-check           { background: rgba(99,102,241,.15); color: #6366f1; }
.b1-ss-broker_check    { background: rgba(139,92,246,.15); color: #8b5cf6; }
.b1-ss-deposit_in      { background: rgba(6,182,212,.15);  color: #06b6d4; }
.b1-ss-documents       { background: rgba(59,130,246,.15); color: #3b82f6; }
.b1-ss-traded          { background: rgba(245,158,11,.15); color: #f59e0b; }
.b1-ss-done_sales      { background: rgba(34,197,94,.15);  color: #22c55e; }
.b1-ss-done_support    { background: rgba(16,185,129,.15); color: #10b981; }
.b1-ss-back_to_sales   { background: rgba(249,115,22,.15); color: #f97316; }
.b1-ss-approved        { background: rgba(132,204,22,.15); color: #84cc16; }
.b1-ss-removed         { background: rgba(239,68,68,.12);  color: #ef4444; }

/* ── VIKI PANEL ── */
.b1-viki-panel { padding: 0; }
.b1-viki-mark-all { font-size: 10px; color: var(--b1-t3); cursor: pointer; padding: 3px 8px; border-radius: 6px; }
.b1-viki-mark-all:hover { color: var(--b1-ac); background: var(--b1-ac-soft); }
.b1-sync-bar {
  display: flex; align-items: center; gap: 8px; padding: 8px 16px;
  background: var(--b1-bg); border-bottom: 1px solid var(--b1-brd);
}
.b1-sync-dot {
  width: 7px; height: 7px; border-radius: 50%; background: var(--b1-t3);
  flex-shrink: 0; transition: background .3s;
}
.b1-sync-dot.active { background: var(--b1-green); animation: b1syncpulse 1s ease-in-out infinite; }
@keyframes b1syncpulse { 0%,100% { opacity: 1; } 50% { opacity: .4; } }
.b1-sync-lbl { font-size: 10px; color: var(--b1-t3); }
.b1-sync-time { font-size: 10px; font-weight: 600; color: var(--b1-t1); }
.b1-sync-btn {
  display: flex; align-items: center; gap: 4px; padding: 4px 10px;
  border-radius: 6px; background: var(--b1-act); border: 1px solid var(--b1-brd);
  color: var(--b1-t2); font-size: 10px; font-weight: 600; cursor: pointer;
}
.b1-sync-btn:disabled { opacity: .5; cursor: not-allowed; }
.b1-sync-btn svg { width: 11px; height: 11px; stroke: currentColor; fill: none; stroke-width: 2; }
.b1-viki-list { display: flex; flex-direction: column; gap: 1px; padding: 8px 0; }
.b1-viki-empty {
  display: flex; align-items: center; gap: 8px; padding: 20px 16px;
  font-size: 12px; color: var(--b1-t3);
}
.b1-viki-empty svg { width: 18px; height: 18px; stroke: var(--b1-t3); fill: none; stroke-width: 2; flex-shrink: 0; }
.b1-viki-item {
  display: flex; align-items: flex-start; gap: 10px; padding: 10px 16px;
  cursor: pointer; transition: background .1s;
}
.b1-viki-item:hover { background: var(--b1-act); }
.b1-viki-unread { background: rgba(99,102,241,.05); }
.b1-viki-alert { border-left: 2px solid var(--b1-amber); }
.b1-viki-icon {
  width: 28px; height: 28px; border-radius: 8px; display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.b1-viki-icon svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; }
.b1-viki-icon-deposit { background: rgba(34,197,94,.12); color: var(--b1-green); }
.b1-viki-icon-alert { background: rgba(245,158,11,.12); color: var(--b1-amber); }
.b1-viki-icon-info { background: var(--b1-ac-soft); color: var(--b1-ac); }
.b1-viki-body { flex: 1; min-width: 0; }
.b1-viki-msg { font-size: 12px; font-weight: 500; color: var(--b1-t1); line-height: 1.4; }
.b1-viki-meta { font-size: 10px; color: var(--b1-t3); margin-top: 2px; }
.b1-viki-unread-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--b1-ac); flex-shrink: 0; margin-top: 4px; }

/* ── Profile panel ── */
.c1-main .c1-prof-panel { background: var(--b1-bg) !important; }
.c1-main .c1-prof-head { background: var(--b1-surface) !important; border-bottom-color: var(--b1-brd) !important; }
.c1-main .c1-prof-brand-name { color: var(--b1-t1) !important; }
.c1-main .c1-prof-brand-name span { color: var(--b1-ac) !important; }
.c1-main .c1-tz-lbl { color: var(--b1-t3) !important; }
.c1-main .c1-tz-t { color: var(--b1-t1) !important; }
.c1-main .c1-prof-av { background: var(--b1-ac) !important; }
.c1-main .c1-prof-name { color: var(--b1-t1) !important; }
.c1-main .c1-prof-role { color: var(--b1-t3) !important; }
.c1-main .c1-prof-toggle { border-color: var(--b1-brd) !important; color: var(--b1-t3) !important; }
.c1-main .c1-prof-toggle.online { border-color: var(--b1-green) !important; color: var(--b1-green) !important; background: rgba(34,197,94,.08) !important; }
.c1-main .c1-prof-scroll { background: var(--b1-bg) !important; }
.c1-main .c1-nc-lbl { color: var(--b1-t3) !important; }
.c1-main .c1-nb { border-color: var(--b1-brd) !important; }
.c1-main .c1-nb-dp { background: rgba(99,102,241,.1) !important; color: var(--b1-ac) !important; }
.c1-main .c1-nb-rf { background: rgba(239,68,68,.08) !important; color: #f87171 !important; }
.c1-main .c1-nb-na { background: var(--b1-act) !important; color: var(--b1-t2) !important; }
.c1-main .c1-nb-logout { background: rgba(239,68,68,.08) !important; color: #f87171 !important; }
.c1-main .c1-collapse-bar-lg { background: var(--b1-surface) !important; border-top-color: var(--b1-brd) !important; }

/* ── SUMMARY BAR ── */
.b1-summary-bar {
  display: flex; align-items: center; gap: 0; padding: 0 16px; height: 44px;
  background: var(--b1-surface); border-bottom: 1px solid var(--b1-brd);
  flex-shrink: 0; overflow-x: auto; -webkit-overflow-scrolling: touch;
}
.b1-sb-item { display: flex; flex-direction: column; align-items: center; padding: 0 10px; }
.b1-sb-val { font-size: 15px; font-weight: 800; color: var(--b1-t1); line-height: 1; }
.b1-sb-lbl { font-size: 8px; color: var(--b1-t3); text-transform: uppercase; letter-spacing: .4px; margin-top: 1px; white-space: nowrap; }
.b1-sb-active { color: var(--b1-ac); }
.b1-sb-dep { color: var(--b1-green); }
.b1-sb-cpa { color: var(--b1-amber); }
.b1-sb-sep { width: 1px; height: 20px; background: var(--b1-brd); flex-shrink: 0; }
.b1-sb-sync { flex-direction: row; gap: 5px; cursor: pointer; }
.b1-sb-sync-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--b1-t3); flex-shrink: 0; }
.b1-sb-sync-dot.active { background: var(--b1-green); }
.c1-hp { flex: 1; }

/* Add button */
.b1-add-btn {
  display: flex; align-items: center; gap: 5px; padding: 6px 14px;
  background: var(--b1-ac); color: #fff; border: none; border-radius: 8px;
  font-size: 12px; font-weight: 600; cursor: pointer; white-space: nowrap; flex-shrink: 0;
  transition: opacity .15s;
}
.b1-add-btn:hover { opacity: .85; }
.b1-add-btn svg { width: 14px; height: 14px; }

/* ── BROKER LIST ── */
.b1-list { flex: 1; overflow-y: auto; padding: 10px 12px 30px; display: flex; flex-direction: column; gap: 6px; }

.b1-box {
  background: var(--b1-surface); border: 1px solid var(--b1-brd);
  border-radius: 12px; overflow: hidden; transition: border-color .12s;
}
.b1-box:hover { border-color: rgba(99,102,241,.4); }
.b1-box-inactive { opacity: .6; }
.b1-box-expanded { border-color: var(--b1-ac) !important; }

.b1-box-row {
  display: flex; align-items: center; gap: 10px; padding: 10px 12px 10px 0;
  cursor: pointer; position: relative;
}
.b1-accent { width: 3px; align-self: stretch; border-radius: 0 3px 3px 0; flex-shrink: 0; min-height: 36px; }
.b1-av {
  width: 34px; height: 34px; border-radius: 10px; display: flex; align-items: center; justify-content: center;
  font-size: 11px; font-weight: 800; color: #fff; flex-shrink: 0; letter-spacing: -.3px;
}
.b1-box-info { flex: 1; min-width: 0; }
.b1-box-name {
  font-size: 13px; font-weight: 600; color: var(--b1-t1); display: flex; align-items: center; gap: 5px;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.b1-chv { width: 14px; height: 14px; stroke: var(--b1-t3); transition: transform .2s; flex-shrink: 0; }
.b1-chv.open { transform: rotate(180deg); }
.b1-box-meta { display: flex; align-items: center; gap: 5px; margin-top: 3px; flex-wrap: wrap; }
.b1-meta-sep { color: var(--b1-t3); font-size: 10px; }
.b1-meta-txt { font-size: 10px; color: var(--b1-t2); }
.b1-meta-cpa { color: var(--b1-amber) !important; font-weight: 600; }
.b1-meta-dim { color: var(--b1-t3) !important; }

/* Chips */
.b1-chip {
  display: inline-flex; align-items: center; padding: 1px 6px; border-radius: 10px;
  font-size: 9px; font-weight: 700; letter-spacing: .3px; text-transform: uppercase;
}
.b1-chip-reg { background: rgba(34,197,94,.12); color: var(--b1-green); }
.b1-chip-unreg { background: rgba(239,68,68,.1); color: #f87171; }
.b1-chip-ct { background: rgba(245,158,11,.12); color: var(--b1-amber); }
.b1-chip-active { background: var(--b1-ac-soft); color: var(--b1-ac); }
.b1-chip-off { font-size: 10px; color: var(--b1-t3); }

.b1-status-badge { padding: 3px 9px; border-radius: 8px; font-size: 10px; font-weight: 600; flex-shrink: 0; }
.b1-badge-active { background: rgba(34,197,94,.1); color: var(--b1-green); }
.b1-badge-inactive { background: var(--b1-act); color: var(--b1-t3); }

.b1-detail-btn {
  background: none; border: none; padding: 6px 8px; color: var(--b1-t3);
  cursor: pointer; border-radius: 6px; display: flex; align-items: center; flex-shrink: 0;
}
.b1-detail-btn:hover { background: var(--b1-act); color: var(--b1-t1); }
.b1-detail-btn svg { width: 16px; height: 16px; stroke: currentColor; fill: none; stroke-width: 2; }

/* Expanded inline detail */
.b1-box-detail {
  padding: 12px 16px 14px; border-top: 1px solid var(--b1-brd); background: var(--b1-bg);
  animation: b1FadeIn .15s ease;
}
@keyframes b1FadeIn { from { opacity: 0; transform: translateY(-4px); } to { opacity: 1; transform: none; } }
.b1-detail-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px 16px; }
.b1-df { display: flex; flex-direction: column; gap: 2px; }
.b1-df-l { font-size: 9px; font-weight: 600; text-transform: uppercase; letter-spacing: .4px; color: var(--b1-t3); }
.b1-df-v { font-size: 12px; font-weight: 500; color: var(--b1-t1); }
.b1-val-accent { color: var(--b1-ac) !important; font-weight: 700 !important; }
.b1-val-cpa { color: var(--b1-amber) !important; font-weight: 700 !important; }
.b1-val-green { color: var(--b1-green) !important; font-weight: 700 !important; }
.b1-mono { font-family: 'JetBrains Mono', monospace; font-size: 11px !important; }

/* Pipeline strip in accordion */
.b1-pipeline-wrap { margin-top: 12px; }
.b1-pipeline-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; color: var(--b1-t3); margin-bottom: 6px; }
.b1-pipeline-row { display: flex; gap: 4px; overflow-x: auto; padding-bottom: 2px; }
.b1-pipe-stage {
  display: flex; flex-direction: column; align-items: center; flex-shrink: 0;
  background: var(--b1-surface); border: 1px solid var(--b1-brd); border-radius: 6px;
  padding: 5px 7px; border-top: 2px solid var(--ps-clr); min-width: 36px;
}
.b1-pipe-num { font-size: 13px; font-weight: 800; color: var(--ps-clr); line-height: 1; }
.b1-pipe-lbl { font-size: 7px; color: var(--b1-t3); text-transform: uppercase; letter-spacing: .2px; margin-top: 2px; }

/* Box actions */
.b1-box-actions { margin-top: 12px; display: flex; gap: 8px; flex-wrap: wrap; }
.b1-act-btn {
  display: flex; align-items: center; gap: 5px; padding: 6px 12px;
  border-radius: 8px; border: 1px solid var(--b1-brd); font-size: 11px; font-weight: 600;
  cursor: pointer; background: var(--b1-act); color: var(--b1-t1); transition: all .12s;
}
.b1-act-btn:hover { border-color: var(--b1-ac); color: var(--b1-ac); }
.b1-act-btn svg { width: 13px; height: 13px; stroke: currentColor; fill: none; stroke-width: 2; }
.b1-act-detail { border-color: var(--b1-ac); color: var(--b1-ac); background: var(--b1-ac-soft); }
.b1-act-edit { border-color: var(--b1-t3); }
.b1-act-danger { border-color: rgba(239,68,68,.3); color: #f87171; }
.b1-act-danger:hover { border-color: var(--b1-red) !important; background: rgba(239,68,68,.08) !important; }

/* Loading / empty */
.b1-loading { display: flex; flex-direction: column; align-items: center; justify-content: center; flex: 1; gap: 8px; padding: 40px; }
.b1-loading-txt { font-size: 11px; color: var(--b1-t3); }
.b1-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px; padding: 50px 20px; text-align: center; }
.b1-empty-icon svg { width: 40px; height: 40px; stroke: var(--b1-t3); }
.b1-empty-msg { font-size: 14px; font-weight: 600; color: var(--b1-t2); }
.b1-empty-cta { padding: 6px 16px; border-radius: 8px; background: var(--b1-ac-soft); border: 1px solid var(--b1-ac); color: var(--b1-ac); font-size: 12px; font-weight: 600; cursor: pointer; }

/* Spinner */
.c1-main .c1-spinner { width: 22px; height: 22px; border: 3px solid var(--b1-brd); border-top-color: var(--b1-ac); border-radius: 50%; animation: b1spin .7s linear infinite; }
.c1-spinner-sm { width: 14px !important; height: 14px !important; border-width: 2px !important; }
@keyframes b1spin { to { transform: rotate(360deg); } }

/* ── RIGHT DRAWER ── */
.b1-drawer-wrap { position: fixed; inset: 0; background: rgba(0,0,0,.6); z-index: 400; display: flex; justify-content: flex-end; }
.b1-drawer {
  width: 100%; max-width: 420px; background: var(--b1-surface); height: 100%;
  display: flex; flex-direction: column; overflow: hidden; border-left: 1px solid var(--b1-brd);
}
.b1-drawer-head {
  display: flex; align-items: center; gap: 10px; padding: 14px 16px;
  border-bottom: 1px solid var(--b1-brd); flex-shrink: 0;
}
.b1-drawer-av { width: 40px; height: 40px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: 800; color: #fff; flex-shrink: 0; }
.b1-drawer-title { flex: 1; min-width: 0; }
.b1-drawer-name { font-size: 15px; font-weight: 700; color: var(--b1-t1); }
.b1-drawer-sub { margin-top: 3px; display: flex; align-items: center; flex-wrap: wrap; gap: 4px; }
.b1-drawer-close { background: var(--b1-act); border: none; color: var(--b1-t2); border-radius: 8px; padding: 7px; cursor: pointer; display: flex; align-items: center; flex-shrink: 0; }
.b1-drawer-close svg { width: 16px; height: 16px; }
.b1-drawer-body { flex: 1; overflow-y: auto; padding: 16px; display: flex; flex-direction: column; gap: 16px; -webkit-overflow-scrolling: touch; }

/* Drawer tab bar */
.b1-dtab-bar { display: flex; border-bottom: 1px solid var(--b1-brd); flex-shrink: 0; }
.b1-dtab {
  flex: 1; text-align: center; padding: 9px 4px; font-size: 11px; font-weight: 600;
  color: var(--b1-t3); cursor: pointer; border-bottom: 2px solid transparent;
  transition: all .15s;
}
.b1-dtab:hover { color: var(--b1-t1); }
.b1-dtab.on { color: var(--b1-ac); border-bottom-color: var(--b1-ac); }

/* LEFT DRAWER */
.b1-drawer-wrap-left { justify-content: flex-start; }
.b1-drawer-left { border-left: none; border-right: 1px solid var(--b1-brd); }

/* Drawer sections */
.b1-exp-sec { display: flex; flex-direction: column; gap: 8px; }
.b1-exp-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--b1-t3); }
.b1-exp-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px 12px; }
.b1-exp-field { display: flex; flex-direction: column; gap: 2px; }
.b1-exp-full { grid-column: 1 / -1; }
.b1-exp-fl { font-size: 9px; font-weight: 600; text-transform: uppercase; letter-spacing: .3px; color: var(--b1-t3); }
.b1-exp-fv { font-size: 12px; font-weight: 500; color: var(--b1-t1); }
.b1-exp-empty { font-size: 11px; color: var(--b1-t3); padding: 4px 0; }
.b1-exp-loading { display: flex; padding: 8px 0; }
.b1-exp-more { font-size: 10px; color: var(--b1-t3); padding: 6px 0; text-align: center; }
.b1-monthly-chart { gap: 5px; }

/* Activity rows */
.b1-act-row { display: flex; align-items: center; gap: 10px; padding: 7px 0; border-bottom: 1px solid var(--b1-brd); }
.b1-act-badge { width: 26px; height: 26px; border-radius: 6px; font-size: 8px; font-weight: 800; display: flex; align-items: center; justify-content: center; flex-shrink: 0; letter-spacing: .2px; }
.b1-act-dep { background: var(--b1-ac-soft); color: var(--b1-ac); }
.b1-act-av { width: 26px; height: 26px; border-radius: 50%; background: var(--b1-ac-soft); color: var(--b1-ac); font-size: 9px; font-weight: 800; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.b1-act-body { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 1px; }
.b1-act-main { font-size: 12px; font-weight: 600; color: var(--b1-t1); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.b1-act-meta { font-size: 10px; color: var(--b1-t3); }
.b1-act-date { font-size: 10px; color: var(--b1-t3); white-space: nowrap; }

/* Detail actions (scheduled call) */
.b1-detail-actions { display: flex; flex-direction: column; gap: 8px; }
.b1-sched-btn {
  display: flex; align-items: center; gap: 7px; padding: 9px 14px; border-radius: 10px;
  background: var(--b1-ac-soft); border: 1px solid var(--b1-ac); color: var(--b1-ac);
  font-size: 12px; font-weight: 600; cursor: pointer; transition: opacity .15s;
}
.b1-sched-btn:hover { opacity: .8; }
.b1-sched-btn svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; flex-shrink: 0; }

/* Deposit range pills */
.b1-dep-range-row { display: flex; gap: 6px; flex-wrap: wrap; margin-bottom: 8px; }
.b1-dep-range-pill {
  padding: 3px 10px; border-radius: 12px; border: 1px solid var(--b1-brd);
  font-size: 10px; font-weight: 600; color: var(--b1-t3); cursor: pointer; transition: all .12s;
}
.b1-dep-range-pill.on { background: var(--b1-ac-soft); border-color: var(--b1-ac); color: var(--b1-ac); }

/* Deposit table in drawer */
.b1-dep-table { display: flex; flex-direction: column; gap: 0; border: 1px solid var(--b1-brd); border-radius: 8px; overflow: hidden; }
.b1-dep-thead {
  display: grid; grid-template-columns: 80px 1fr 60px 80px; gap: 6px;
  padding: 6px 10px; background: var(--b1-bg);
  font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .3px; color: var(--b1-t3);
}
.b1-dep-trow {
  display: grid; grid-template-columns: 80px 1fr 60px 80px; gap: 6px;
  padding: 7px 10px; border-top: 1px solid var(--b1-brd);
  font-size: 11px; color: var(--b1-t1); align-items: center;
}
.b1-dep-trow:hover { background: var(--b1-act); }
.b1-dep-ss { font-size: 9px; font-weight: 700; padding: 2px 5px; border-radius: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

/* Pipeline detail in drawer */
.b1-pipeline-detail {
  display: flex; flex-wrap: wrap; gap: 6px;
}
.b1-pd-stage {
  display: flex; flex-direction: column; align-items: center; position: relative;
  background: var(--b1-bg); border: 1px solid var(--b1-brd); border-radius: 8px;
  padding: 8px 10px; min-width: 52px; border-top: 3px solid var(--ps-clr);
}
.b1-pd-num { font-size: 18px; font-weight: 800; color: var(--ps-clr); line-height: 1; }
.b1-pd-lbl { font-size: 8px; color: var(--b1-t3); text-transform: uppercase; letter-spacing: .3px; margin-top: 3px; text-align: center; }
.b1-pd-arrow { position: absolute; right: -10px; top: 50%; transform: translateY(-50%); color: var(--b1-t3); font-size: 10px; z-index: 1; display: none; }

/* Conversion rate */
.b1-conv-rate { display: flex; align-items: center; gap: 8px; padding: 8px 12px; background: var(--b1-bg); border-radius: 8px; border: 1px solid var(--b1-brd); }
.b1-conv-lbl { font-size: 11px; color: var(--b1-t2); flex: 1; }
.b1-conv-val { font-size: 18px; font-weight: 800; color: var(--b1-green); }

/* Status distribution bars */
.b1-status-dist { display: flex; flex-direction: column; gap: 6px; }
.b1-dist-row { display: flex; align-items: center; gap: 8px; }
.b1-dist-lbl { width: 32px; font-size: 9px; font-weight: 700; color: var(--b1-t3); flex-shrink: 0; }
.b1-dist-track { flex: 1; height: 10px; background: var(--b1-bg); border-radius: 5px; overflow: hidden; }
.b1-dist-fill { height: 100%; border-radius: 5px; transition: width .35s ease; min-width: 2px; }
.b1-dist-val { width: 28px; font-size: 10px; font-weight: 700; text-align: right; flex-shrink: 0; }

/* Agent rows */
.b1-agent-row { display: flex; align-items: center; gap: 10px; padding: 8px 0; border-bottom: 1px solid var(--b1-brd); }
.b1-agent-av { width: 32px; height: 32px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 800; color: #fff; flex-shrink: 0; }
.b1-agent-info { flex: 1; min-width: 0; }
.b1-agent-name { font-size: 12px; font-weight: 600; color: var(--b1-t1); }
.b1-agent-role { font-size: 10px; color: var(--b1-t3); }
.b1-agent-stats { display: flex; flex-direction: column; gap: 3px; align-items: flex-end; min-width: 60px; }
.b1-agent-dep-count { font-size: 11px; font-weight: 700; color: var(--b1-t1); }
.b1-agent-bar-wrap { width: 56px; height: 5px; background: var(--b1-bg); border-radius: 3px; overflow: hidden; }
.b1-agent-bar { height: 100%; border-radius: 3px; transition: width .3s ease; }

/* Agent donut / share */
.b1-agent-donut-wrap { display: flex; flex-direction: column; gap: 6px; }
.b1-agent-share-row { display: flex; align-items: center; gap: 8px; }
.b1-agent-share-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
.b1-agent-share-name { width: 52px; font-size: 10px; color: var(--b1-t2); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex-shrink: 0; }
.b1-agent-share-track { flex: 1; height: 8px; background: var(--b1-bg); border-radius: 4px; overflow: hidden; }
.b1-agent-share-fill { height: 100%; border-radius: 4px; transition: width .3s ease; }
.b1-agent-share-pct { width: 30px; font-size: 10px; font-weight: 700; color: var(--b1-t2); text-align: right; flex-shrink: 0; }

/* Add / Edit Broker Form */
.b1-add-form { display: flex; flex-direction: column; gap: 14px; }
.b1-form-group { display: flex; flex-direction: column; gap: 5px; }
.b1-form-row-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.b1-form-lbl { font-size: 11px; font-weight: 600; color: var(--b1-t2); }
.b1-req { color: var(--b1-red); }
.b1-form-input {
  padding: 8px 12px; background: var(--b1-bg); border: 1px solid var(--b1-brd);
  border-radius: 8px; color: var(--b1-t1); font-size: 13px; outline: none; transition: border-color .12s;
}
.b1-form-input:focus { border-color: var(--b1-ac); }
.b1-form-input::placeholder { color: var(--b1-t3); }
.b1-toggle-row { display: flex; align-items: center; gap: 10px; }
.b1-toggle-btn {
  width: 36px; height: 20px; border-radius: 10px; background: var(--b1-brd);
  border: none; cursor: pointer; position: relative; transition: background .15s; flex-shrink: 0;
}
.b1-toggle-btn.on { background: var(--b1-ac); }
.b1-toggle-dot { position: absolute; top: 2px; left: 2px; width: 16px; height: 16px; border-radius: 50%; background: #fff; transition: left .15s; }
.b1-toggle-btn.on .b1-toggle-dot { left: 18px; }
.b1-toggle-lbl { font-size: 12px; font-weight: 500; color: var(--b1-t1); }
.b1-form-error { font-size: 11px; color: var(--b1-red); padding: 6px 10px; background: rgba(239,68,68,.08); border-radius: 6px; }
.b1-form-success { font-size: 11px; color: var(--b1-green); padding: 6px 10px; background: rgba(34,197,94,.08); border-radius: 6px; }
.b1-submit-btn {
  padding: 10px 16px; background: var(--b1-ac); color: #fff; border: none;
  border-radius: 10px; font-size: 13px; font-weight: 700; cursor: pointer;
  transition: opacity .15s; margin-top: 4px;
}
.b1-submit-btn:disabled { opacity: .5; cursor: not-allowed; }
.b1-submit-btn:not(:disabled):hover { opacity: .88; }

/* Toast */
.br1-toast {
  position: fixed; bottom: 28px; left: 50%; transform: translateX(-50%);
  z-index: 99999; padding: 10px 22px; border-radius: 24px; color: #fff;
  font-size: .85rem; font-weight: 600; box-shadow: 0 4px 20px rgba(0,0,0,.25);
  pointer-events: none; white-space: nowrap; height: auto;
  display: inline-flex; align-items: center;
}
.br1-toast-fade-enter-active, .br1-toast-fade-leave-active { transition: opacity .25s, transform .25s; }
.br1-toast-fade-enter, .br1-toast-fade-leave-to { opacity: 0; transform: translateX(-50%) translateY(10px); }

/* Drawer transitions */
.b1-drawer-enter-active, .b1-drawer-leave-active { transition: transform .25s ease, opacity .25s ease; }
.b1-drawer-enter, .b1-drawer-leave-to { transform: translateX(100%); opacity: 0; }
.b1-drawer-left-enter-active, .b1-drawer-left-leave-active { transition: transform .25s ease, opacity .25s ease; }
.b1-drawer-left-enter, .b1-drawer-left-leave-to { transform: translateX(-100%); opacity: 0; }

/* Mobile */
@media (max-width: 480px) {
  .b1-exp-grid { grid-template-columns: 1fr; }
  .b1-detail-grid { grid-template-columns: 1fr; }
  .b1-drawer { max-width: 100%; }
  .b1-dep-thead, .b1-dep-trow { grid-template-columns: 70px 1fr 55px; }
  .b1-dep-thead span:last-child, .b1-dep-trow span:last-child { display: none; }
  .b1-form-row-2 { grid-template-columns: 1fr; }
}
</style>
